(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4108],{

/***/ 44701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgHandset = function SvgHandset(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 578.106 578.106",
    style: {
      enableBackground: "new 0 0 578.106 578.106"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M577.83 456.128c1.225 9.385-1.635 17.545-8.568 24.48l-81.396 80.781c-3.672 4.08-8.465 7.551-14.381 10.404-5.916 2.857-11.729 4.693-17.439 5.508-.408 0-1.635.105-3.676.309-2.037.203-4.689.307-7.953.307-7.754 0-20.301-1.326-37.641-3.979s-38.555-9.182-63.645-19.584c-25.096-10.404-53.553-26.012-85.376-46.818-31.823-20.805-65.688-49.367-101.592-85.68-28.56-28.152-52.224-55.08-70.992-80.783-18.768-25.705-33.864-49.471-45.288-71.299-11.425-21.828-19.993-41.616-25.705-59.364S4.59 177.362 2.55 164.51-.306 141.56.102 134.216c.408-7.344.612-11.424.612-12.24.816-5.712 2.652-11.526 5.508-17.442s6.324-10.71 10.404-14.382L98.022 8.756c5.712-5.712 12.24-8.568 19.584-8.568 5.304 0 9.996 1.53 14.076 4.59s7.548 6.834 10.404 11.322l65.484 124.236c3.672 6.528 4.692 13.668 3.06 21.42-1.632 7.752-5.1 14.28-10.404 19.584l-29.988 29.988c-.816.816-1.53 2.142-2.142 3.978s-.918 3.366-.918 4.59c1.632 8.568 5.304 18.36 11.016 29.376 4.896 9.792 12.444 21.726 22.644 35.802s24.684 30.293 43.452 48.653c18.36 18.77 34.68 33.354 48.96 43.76 14.277 10.4 26.215 18.053 35.803 22.949 9.588 4.896 16.932 7.854 22.031 8.871l7.648 1.531c.816 0 2.145-.307 3.979-.918 1.836-.613 3.162-1.326 3.979-2.143l34.883-35.496c7.348-6.527 15.912-9.791 25.705-9.791 6.938 0 12.443 1.223 16.523 3.672h.611l118.115 69.768c8.571 5.308 13.67 12.038 15.303 20.198z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgHandset);

/***/ }),

/***/ 12889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgShip = function SvgShip(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17.112 11.208h-4.999c-.883 0-1.594.693-1.594 1.554v10.334l15.512-7.246 15.512 7.246V12.762c0-.86-.71-1.554-1.594-1.554H17.112Zm17.882-1.554v-.945c0-.862-.711-1.555-1.595-1.555h-3.856L28.853 1H23.21l-.69 6.154h-3.856c-.883 0-1.573.693-1.573 1.555v.945h17.904Zm-8.941 7.897L3 28.326l6.83 19.408c3.167-1.428 7.239-2.772 11.418-2.772 6.7 0 12.108 3.108 19.175 4.705h1.163l7.52-21.34L26.052 17.55Z"
  })));
};

/* harmony default export */ __webpack_exports__["Z"] = (SvgShip);

/***/ }),

/***/ 50938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _slug_; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(16835);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/sections/head-tags/head-tags.tsx + 5 modules
var head_tags = __webpack_require__(92848);
// EXTERNAL MODULE: ./src/components/sections/ugc/ugc.data.ts
var ugc_data = __webpack_require__(99805);
// EXTERNAL MODULE: ./src/components/sections/ugc/ugc.tsx + 15 modules
var ugc = __webpack_require__(14320);
// EXTERNAL MODULE: ./src/constants/shipLanding.ts
var shipLanding = __webpack_require__(66603);
// EXTERNAL MODULE: ./src/contexts/locale-config/locale-config.tsx
var locale_config = __webpack_require__(36097);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./src/components/atoms/image/image.tsx + 2 modules
var image_image = __webpack_require__(87647);
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
;// CONCATENATED MODULE: ./src/components/sections/cabin/cabin-module/cabin-module.style.tsx


var StyledWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e15d69il2"
} : 0)("background-color:", function (props) {
  return props.theme.colors['main1-70'];
}, ";display:flex;flex-direction:column;align-items:center;justify-content:space-around;height:100%;" + ( true ? "" : 0));
var StyledHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e15d69il1"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.headlineM;
}, ";font-weight:500;line-height:1.5;margin:0;padding:16px 0 0;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.headlineXL;
}, ";margin:0;padding:24px 0 0;line-height:normal;}" + ( true ? "" : 0));
var StyledContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e15d69il0"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";text-align:center;margin:0;padding:7px 12px 16px;line-height:21px;max-width:100%;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{padding:19px 64px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/components/atoms/dreamlines-button/dreamlines-button.tsx
var dreamlines_button = __webpack_require__(2730);
// EXTERNAL MODULE: ./src/utils/EventTracker.ts
var EventTracker = __webpack_require__(6946);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/sections/cabin/cabin-module/cabin-module.tsx







var CabinModule = function CabinModule(_ref) {
  var heading = _ref.heading,
      description = _ref.description,
      buttonText = _ref.buttonText,
      redirectUrl = _ref.redirectUrl,
      shipName = _ref.shipName;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledWrapper, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeader, {
      children: heading
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContent, {
      children: description
    }), redirectUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
      tertiary: true,
      redirectUrl: redirectUrl,
      wrapperStyle: {
        marginBottom: '16px'
      },
      style: {
        borderColor: global_style/* theme.shades.white */.rS.shades.white,
        color: global_style/* theme.shades.white */.rS.shades.white
      },
      onClick: function onClick() {
        EventTracker/* eventTracker.track */.xT.track({
          event: 'click',
          category: 'link-to-subpage',
          action: 'cabin-and-deck-module',
          label: "ship-".concat(shipName)
        });
      },
      children: buttonText
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
;// CONCATENATED MODULE: ./src/components/sections/cabin/cabin.style.tsx



var _templateObject, _templateObject2, _templateObject3;

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var StyledCabinWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ev0w6xb2"
} : 0)("width:100%;height:100%;position:relative;", global_style/* media.tablet */.BC.tablet(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n        height: 315px;\n        width: 500px;\n    "]))), " ", global_style/* media.desktop */.BC.desktop(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n    position: absolute;\n    right: 0;\n    top: 50%;\n    transform: translateY(-50%);\n    overflow: hidden;\n    "]))), ";" + ( true ? "" : 0));
var StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ev0w6xb1"
} : 0)("height:300px;position:relative;", global_style/* media.tablet */.BC.tablet(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n        height: 350px;\n    "]))), ";" + ( true ? "" : 0));
var StyledCabinContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ev0w6xb0"
} : 0)( true ? {
  name: "b8xei4",
  styles: "max-width:1170px;position:relative;width:100%"
} : 0);
;// CONCATENATED MODULE: ./src/components/sections/cabin/cabin.tsx


var _excluded = ["imgUrl", "placeholder", "description", "cabinData", "shipName"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var Cabin = function Cabin(_ref) {
  var imgUrl = _ref.imgUrl,
      placeholder = _ref.placeholder,
      description = _ref.description,
      cabinData = _ref.cabinData,
      shipName = _ref.shipName,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSection, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(image_image/* NextImage */.o, {
      fill: true,
      placeholder: placeholder,
      imgUrl: imgUrl,
      isBackground: true,
      customContentStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      },
      style: {
        objectFit: 'cover'
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCabinContainer, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCabinWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CabinModule, _objectSpread(_objectSpread({}, rest), {}, {
            description: formatCabinDesc(description, cabinData),
            shipName: shipName
          }))
        })
      })
    })
  });
};
var formatCabinDesc = function formatCabinDesc(cabinDesc, _ref2) {
  var title = _ref2.title,
      cabinCategories = _ref2.numberOfCabins,
      decks = _ref2.decks,
      smallestSquare = _ref2.smallestSquare,
      biggestSquare = _ref2.biggestSquare,
      passengers = _ref2.passengers;
  // any because I don't understand the ts error that fires below in the replace funct
  var replacementMap = {
    '[shipName]': title,
    '[cabinCategories]': cabinCategories,
    '[decks]': decks,
    '[passengers]': passengers,
    '[smallestSquare]': smallestSquare,
    '[biggestSquare]': biggestSquare
  };
  return cabinDesc.replace(/\[(([A-Za-z0-9#]+\s?))+]/g, function (matched) {
    return replacementMap[matched];
  });
};
// EXTERNAL MODULE: ./src/utils/translation-service.ts
var translation_service = __webpack_require__(21449);
// EXTERNAL MODULE: ./src/utils/buildVersion.ts
var buildVersion = __webpack_require__(76577);
;// CONCATENATED MODULE: ./src/modules/cabin-mod.tsx






var CabinMod = function CabinMod(_ref) {
  var getLandingPage = _ref.getLandingPage,
      modulesData = _ref.modulesData;
  var localeConfig = react.useContext(locale_config/* LocaleConfigContext */.nO);
  var assetPrefix = (0,buildVersion/* getAssetsPrefix */.x)();
  var cabinFallbackBackground = "".concat(assetPrefix, "/static/images/ship-fallback-bg.jpg");
  if (!modulesData || !modulesData["ship".concat(getLandingPage.id)]) return null;
  var shipData = modulesData["ship".concat(getLandingPage.id)];
  if (!shipData) return null; //Show the CTA button only when there are cabin subpage data.

  var showCabinPageCTA = Boolean(shipData.cabinInfoByType);
  var title = shipData.title,
      minimumCabinSize = shipData.minimumCabinSize,
      maximumCabinSize = shipData.maximumCabinSize,
      numberOfCabins = shipData.numberOfCabins,
      cabinHeaderImage = shipData.cabinHeaderImage,
      bannerImage = shipData.bannerImage;
  var cabinFactsAndFigures = shipData.factsAndFigures;
  if (!cabinFactsAndFigures) return null;
  var cabinData = {
    passengers: cabinFactsAndFigures.passengerCapacity,
    title: title,
    decks: cabinFactsAndFigures.decks,
    numberOfCabins: numberOfCabins,
    smallestSquare: minimumCabinSize,
    biggestSquare: maximumCabinSize
  };
  var imageUrl = (cabinHeaderImage === null || cabinHeaderImage === void 0 ? void 0 : cabinHeaderImage.image.url) || bannerImage || cabinFallbackBackground || '';
  var imagePlaceholder = (cabinHeaderImage === null || cabinHeaderImage === void 0 ? void 0 : cabinHeaderImage.thumb.url) || '';
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Cabin, {
    heading: translation_service/* TranslationService.translate */.D.translate('cabinHeading'),
    description: translation_service/* TranslationService.translate */.D.translate('cabinDescription'),
    buttonText: translation_service/* TranslationService.translate */.D.translate('cabinButtonText'),
    cabinData: cabinData,
    redirectUrl: showCabinPageCTA ? "/".concat(getLandingPage.url, "/").concat(localeConfig.slugs.deck).replace('//', '/') : null,
    imgUrl: imageUrl,
    placeholder: imagePlaceholder,
    shipName: title
  }, "cabin");
};
// EXTERNAL MODULE: ./src/components/atoms/icon-list/icon-list.style.tsx
var icon_list_style = __webpack_require__(56820);
// EXTERNAL MODULE: ./src/components/sections/highlights/highlights.style.tsx + 3 modules
var highlights_style = __webpack_require__(67250);
;// CONCATENATED MODULE: ./src/components/sections/highlights/highlights.tsx





var Highlights = function Highlights(props) {
  var _props$exclusives;

  if (!props.headline || !props.exclusives) return null;

  var exclusives = !!((_props$exclusives = props.exclusives) !== null && _props$exclusives !== void 0 && _props$exclusives.length) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(highlights_style/* StyledExclusivesOuterWrapper */.zp, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(highlights_style/* StyledLabelledArrowWrapper */.lW, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(highlights_style/* StyledArrowText */.Ft, {
        children: (0,translation_service.__)('exclusiveToDreamlines')
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(highlights_style/* StyledExclusivesInnerWrapper */.a0, {
      children: props.exclusives
    })]
  });

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(highlights_style/* StyledComponentWrapper */.Ll, {
    children: exclusives
  });
};
// EXTERNAL MODULE: ./src/utils/locale.ts + 14 modules
var locale = __webpack_require__(5875);
;// CONCATENATED MODULE: ./src/modules/highlights-mod.tsx








var HighlightsMod = function HighlightsMod(_ref) {
  var _data$exclusives;

  var getLandingPage = _ref.getLandingPage,
      modulesData = _ref.modulesData;
  var data = modulesData["".concat(getLandingPage.type).concat(getLandingPage.id)];
  var isCruiseaway = locale/* portal */.l4 === 'au';

  if (!data || !data.exclusives || isCruiseaway) {
    return null;
  }

  var exclusives = ((_data$exclusives = data.exclusives) === null || _data$exclusives === void 0 ? void 0 : _data$exclusives.length) >= 3 ? [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(icon_list_style/* StyledWrapper */.SD, {
    color: global_style/* theme.labels.onlineBookable */.rS.labels.onlineBookable,
    "data-testid": "icon-list-wrapper",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(icon_list_style/* StyledListItem */.oH, {
      "data-testid": "icon-list-item",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_list_style/* StyledIconWrapper */.Mv, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(highlights_style/* GiftIcon */.Og, {}, "gift")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        children: data.exclusives[0]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(icon_list_style/* StyledListItem */.oH, {
      "data-testid": "icon-list-item",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_list_style/* StyledIconWrapper */.Mv, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(highlights_style/* ExpertIcon */.Fu, {}, "expert")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        children: data.exclusives[1]
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(icon_list_style/* StyledListItem */.oH, {
      "data-testid": "icon-list-item",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_list_style/* StyledIconWrapper */.Mv, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(highlights_style/* BestpriceIcon */.$H, {}, "bestprice")
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
        children: data.exclusives[2]
      })]
    })]
  }, "highlights-exclusives")] : [];
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Highlights, {
    headline: getLandingPage !== null && getLandingPage !== void 0 && getLandingPage.title ? getLandingPage.title : '',
    exclusives: exclusives
  }, "highlights");
};
// EXTERNAL MODULE: ./src/modules/offer-teaser-mod.tsx + 3 modules
var offer_teaser_mod = __webpack_require__(39045);
;// CONCATENATED MODULE: ./src/components/atoms/icon-list/icon-list.tsx





var IconList = function IconList(props) {
  var labels = props.labels,
      icon = props.icon,
      color = props.color;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_list_style/* StyledWrapper */.SD, {
    color: color,
    "data-testid": "icon-list-wrapper",
    children: !!(labels !== null && labels !== void 0 && labels.length) && labels.map(function (label, index) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(icon_list_style/* StyledListItem */.oH, {
        "data-testid": "icon-list-item",
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_list_style/* StyledIconWrapper */.Mv, {
          children: icon
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
          children: label
        })]
      }, label.replace(/ /g, '').substr(0, 5) + index);
    })
  });
};
IconList.defaultProps = {
  color: global_style/* theme.colors.black */.rS.colors.black
};
// EXTERNAL MODULE: ./src/utils/formatting.ts
var formatting = __webpack_require__(62556);
// EXTERNAL MODULE: ./src/utils/device-detection.ts
var device_detection = __webpack_require__(52756);
;// CONCATENATED MODULE: ./src/components/atoms/icon-textbox/icon-textbox.style.tsx


function icon_textbox_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var StyledContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3ja01x2"
} : 0)( true ? {
  name: "1is2kvf",
  styles: "display:flex;align-items:flex-start;margin-bottom:40px"
} : 0);
var StyledIconBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3ja01x1"
} : 0)("background-color:", function (props) {
  return props.theme.colors.main2;
}, ";display:flex;align-items:center;justify-content:center;height:40px;flex-basis:60px;flex-grow:0;flex-shrink:0;position:relative;margin-top:5px;svg{margin-left:-10px;height:20px;width:20px;fill:", function (props) {
  return props.theme.shades.white;
}, ";}&:after{content:'';border-style:solid;border-width:20px 10px 20px 0px;border-color:transparent ", function (props) {
  return props.theme.shades.white;
}, " transparent transparent;position:absolute;right:-1px;top:0;}" + ( true ? "" : 0));
var StyledText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3ja01x0"
} : 0)("p{font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";line-height:22px;margin:0;padding-left:7px;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./public/static/icons/lightingbulb.svg
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgLightingbulb = function SvgLightingbulb(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M37.796 4.89c3.145 3.114 4.877 7.243 4.877 11.627 0 4.756-2.092 9.283-5.74 12.421-2.446 2.104-4.171 4.915-4.99 8.13l-.488 1.911H20.22l-.488-1.912c-.8-3.142-2.582-6.002-5.151-8.269C11.034 25.668 9 21.192 9 16.517c0-4.423 1.777-8.584 5.003-11.719A16.876 16.876 0 0 1 26 .001c4.463.042 8.652 1.778 11.796 4.89Zm-3.527 21.068c2.773-2.386 4.364-5.827 4.364-9.441 0-6.856-5.685-12.487-12.672-12.552a12.827 12.827 0 0 0-9.115 3.65c-2.454 2.384-3.805 5.545-3.805 8.902 0 3.553 1.546 6.955 4.241 9.334 2.873 2.535 4.95 5.685 6.057 9.164h.477V22.33h-4.714v-3.963h13.47v3.963h-4.715v12.685h.475c1.115-3.548 3.152-6.662 5.937-9.057ZM20.885 45.134h9.904v4.103h-9.904v-4.103Z"
  })));
};

/* harmony default export */ var lightingbulb = (SvgLightingbulb);
;// CONCATENATED MODULE: ./src/components/atoms/icon-textbox/icon-textbox.tsx





var IconTextbox = function IconTextbox(_ref) {
  var text = _ref.text;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContainer, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledIconBox, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lightingbulb, {})
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledText, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
        children: text
      })
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
;// CONCATENATED MODULE: ./src/components/atoms/label-icon/label-icon.style.tsx


function label_icon_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var label_icon_style_StyledContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1s3odkx3"
} : 0)("display:flex;align-items:center;flex-direction:", function (props) {
  return props.horizontal ? 'column' : 'row';
}, ";", function (props) {
  return props.horizontal && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{max-width:100px;margin-right:20px;}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{margin-right:50px;}" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var StyledIconContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1s3odkx2"
} : 0)("&>svg{fill:", function (props) {
  return props.iconColor;
}, ";height:", function (props) {
  return props.horizontal ? '30px' : '27px';
}, ";width:", function (props) {
  return props.horizontal ? '30px' : '27px';
}, ";", function (props) {
  return props.horizontal && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("@media ", global_style/* mediaQueries.tablet */.w5.tablet, "{height:30px;width:30px;}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{height:35px;width:35px;}" + ( true ? "" : 0),  true ? "" : 0);
}, ";}" + ( true ? "" : 0));

var _ref2 =  true ? {
  name: "z12o55",
  styles: "order:2"
} : 0;

var StyledAmount = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1s3odkx1"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";color:", function (props) {
  return props.fontColor;
}, ";font-weight:600;padding:0 3px 0 5px;", function (props) {
  return props.horizontal && /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("font-size:", props.theme.fontSize.headlineXS, ";@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{font-size:", props.theme.fontSize.headlineS, ";}" + ( true ? "" : 0),  true ? "" : 0);
}, " ", function (props) {
  return props.iconType === 'buildYear' && !props.horizontal && _ref2;
}, ";" + ( true ? "" : 0));

var _ref =  true ? {
  name: "nvudtm",
  styles: "padding-left:5px"
} : 0;

var StyledLabel = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1s3odkx0"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";color:", function (props) {
  return props.fontColor;
}, ";font-weight:", function (props) {
  return props.horizontal ? '400' : '600';
}, ";white-space:nowrap;text-align:center;text-transform:capitalize;", function (props) {
  return props.iconType === 'buildYear' && !props.horizontal && _ref;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./public/static/icons/yearbuilt.svg
var yearbuilt_path;

function yearbuilt_extends() { yearbuilt_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return yearbuilt_extends.apply(this, arguments); }



var SvgYearbuilt = function SvgYearbuilt(props) {
  return /*#__PURE__*/react.createElement("svg", yearbuilt_extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), yearbuilt_path || (yearbuilt_path = /*#__PURE__*/react.createElement("path", {
    d: "M49.843 22.225c-.079-.703-.899-1.232-1.608-1.232-2.29 0-4.323-1.344-5.176-3.425-.87-2.131-.309-4.616 1.398-6.182a1.39 1.39 0 0 0 .152-1.886 24.75 24.75 0 0 0-3.96-4 1.392 1.392 0 0 0-1.9.154c-1.49 1.65-4.167 2.264-6.236 1.4a5.553 5.553 0 0 1-3.376-5.427A1.387 1.387 0 0 0 27.91.167a24.95 24.95 0 0 0-5.625-.015 1.392 1.392 0 0 0-1.238 1.43c.081 2.319-1.292 4.461-3.423 5.334-2.044.835-4.702.227-6.189-1.41a1.393 1.393 0 0 0-1.887-.157 24.853 24.853 0 0 0-4.044 3.998 1.39 1.39 0 0 0 .15 1.9 5.54 5.54 0 0 1 1.397 6.238c-.863 2.055-2.997 3.379-5.44 3.379-.792-.026-1.356.507-1.444 1.228a25.06 25.06 0 0 0-.01 5.685c.078.705.922 1.23 1.639 1.23 2.177-.056 4.267 1.291 5.144 3.425.874 2.13.312 4.614-1.398 6.182a1.388 1.388 0 0 0-.152 1.883A24.837 24.837 0 0 0 9.345 44.5a1.39 1.39 0 0 0 1.903-.15c1.496-1.655 4.172-2.267 6.232-1.402a5.545 5.545 0 0 1 3.383 5.425 1.388 1.388 0 0 0 1.227 1.46 24.78 24.78 0 0 0 5.624.016 1.391 1.391 0 0 0 1.237-1.431c-.083-2.318 1.293-4.46 3.422-5.332 2.057-.84 4.703-.225 6.191 1.408a1.396 1.396 0 0 0 1.887.158 24.885 24.885 0 0 0 4.044-3.999 1.389 1.389 0 0 0-.149-1.9 5.539 5.539 0 0 1-1.4-6.236c.849-2.027 2.904-3.389 5.113-3.389l.31.009c.717.058 1.376-.495 1.463-1.227.22-1.879.223-3.79.01-5.684ZM25 39.413c-7.96 0-14.413-6.453-14.413-14.413S17.04 10.588 25 10.588 39.413 17.04 39.413 25a14.34 14.34 0 0 1-2.039 7.39l-6.31-6.31a8.814 8.814 0 0 0 .697-3.451c0-2.36-.92-4.58-2.588-6.248a8.777 8.777 0 0 0-6.247-2.588c-.788 0-1.572.105-2.33.312a1 1 0 0 0-.692.697c-.09.34.011.689.277.955 0 0 3.116 3.14 4.158 4.182.11.11.11.37.094.464l-.01.068c-.105 1.146-.307 2.522-.475 3.05-.022.023-.043.042-.066.064l-.07.071c-.535.172-1.932.377-3.096.482v-.007l-.052.013a.666.666 0 0 1-.529-.2c-1.085-1.085-4.079-4.058-4.079-4.058-.268-.267-.544-.324-.727-.324-.428 0-.811.31-.932.753a8.865 8.865 0 0 0 2.28 8.561 8.78 8.78 0 0 0 6.249 2.588 8.816 8.816 0 0 0 3.45-.698l6.38 6.38A14.34 14.34 0 0 1 25 39.412Z"
  })));
};

/* harmony default export */ var yearbuilt = (SvgYearbuilt);
;// CONCATENATED MODULE: ./public/static/icons/user_group.svg
var user_group_path;

function user_group_extends() { user_group_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return user_group_extends.apply(this, arguments); }



var SvgUserGroup = function SvgUserGroup(props) {
  return /*#__PURE__*/react.createElement("svg", user_group_extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), user_group_path || (user_group_path = /*#__PURE__*/react.createElement("path", {
    d: "M24.602 28.424c2.459 0 5.032.534 7.697 1.6 2.666 1.068 3.999 2.464 3.999 4.178v5.223H12.906v-5.223c0-1.724 1.333-3.12 3.998-4.177 2.666-1.057 5.239-1.601 7.698-1.601Zm13.488-3.238.502.007c2.352.067 4.803.597 7.336 1.593C48.643 27.852 50 29.246 50 30.969v5.22H37.459v-1.857c0-2.255-1.642-4.04-4.861-5.3a24.499 24.499 0 0 0-4.293-1.272 11.268 11.268 0 0 1 1.947-.974c2.714-1.067 5.334-1.6 7.838-1.6Zm-26.453-.025.491.007c2.298.066 4.693.595 7.168 1.586.628.255 1.172.52 1.656.807a24.499 24.499 0 0 0-4.339 1.286c-3.05 1.214-4.641 2.915-4.744 5.056l-.005.223.01 1.98H0V30.91c0-1.705 1.326-3.094 3.979-4.156 2.652-1.062 5.212-1.593 7.658-1.593Zm12.965-9.935c1.601 0 2.965.575 4.112 1.735 1.137 1.16 1.715 2.524 1.715 4.115 0 1.59-.568 2.945-1.715 4.084-1.147 1.14-2.51 1.704-4.112 1.704-1.602 0-2.965-.564-4.112-1.704-1.137-1.128-1.715-2.493-1.715-4.084 0-1.59.568-2.956 1.715-4.115 1.136-1.16 2.51-1.735 4.112-1.735ZM38.08 12c1.63 0 3.03.574 4.187 1.733 1.168 1.159 1.746 2.522 1.746 4.112 0 1.589-.589 2.953-1.746 4.08-1.168 1.139-2.557 1.703-4.187 1.703-1.62 0-3.02-.564-4.188-1.702-1.168-1.139-1.746-2.492-1.746-4.081 0-1.59.589-2.953 1.746-4.112C35.06 12.574 36.45 12 38.08 12Zm-26.443.03c1.594 0 2.961.572 4.092 1.726 1.141 1.154 1.707 2.512 1.707 4.095 0 1.582-.576 2.94-1.707 4.063-1.141 1.134-2.498 1.695-4.092 1.695-1.593 0-2.95-.561-4.08-1.684C6.414 20.79 5.85 19.443 5.85 17.86c0-1.583.565-2.94 1.696-4.105 1.141-1.154 2.498-1.725 4.091-1.725Z",
    fillRule: "evenodd"
  })));
};

/* harmony default export */ var user_group = (SvgUserGroup);
;// CONCATENATED MODULE: ./public/static/icons/crew.svg
var crew_path;

function crew_extends() { crew_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return crew_extends.apply(this, arguments); }



var SvgCrew = function SvgCrew(props) {
  return /*#__PURE__*/react.createElement("svg", crew_extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), crew_path || (crew_path = /*#__PURE__*/react.createElement("path", {
    d: "M37.181 15a13.34 13.34 0 0 1 .569 3.861c0 4.878-2.619 9.137-6.513 11.433h.006l.006.002-6.608 3.389 2.624 4.018 8.206-6.453c5.776 2.626 9.654 8.19 9.776 18.26l.003.49H4c0-10.215 3.727-15.814 9.365-18.558l.274-.13 8.29 6.405 2.463-4.032-6.39-3.398a13.247 13.247 0 0 1-6.498-11.079l-.004-.347c0-1.343.2-2.64.569-3.861 2.614 1.313 7.233 3.156 12.556 3.156 5.323 0 9.942-1.844 12.556-3.156Zm1.157 22.579-2.609 2.577-2.608-2.577s-1.405 2.68 2.608 5.746c4.013-3.065 2.609-5.746 2.609-5.746ZM24.643 0C33.96 0 41.5 2.454 41.5 5.482c0 1.336-1.392 2.56-3.948 3.512v2.487C35.677 12.574 30.492 15 24.6 15c-5.869 0-10.907-2.43-12.952-3.52V8.993C9.263 8.043 7.75 6.818 7.75 5.482 7.75 2.454 15.325 0 24.643 0Zm.014 4.754c-1.6 0-2.897 1.277-2.897 2.853 0 .419.094.816.259 1.174h-.26c-.752 0-1.363.601-1.363 1.343 0 .74.61 1.342 1.364 1.342h5.624c.752 0 1.363-.601 1.363-1.342 0-.742-.61-1.343-1.363-1.343h-.09c.166-.358.26-.755.26-1.174 0-1.576-1.297-2.853-2.897-2.853Z"
  })));
};

/* harmony default export */ var crew = (SvgCrew);
// EXTERNAL MODULE: ./public/static/icons/ship.svg
var ship = __webpack_require__(12889);
;// CONCATENATED MODULE: ./public/static/icons/deck.svg
var deck_path;

function deck_extends() { deck_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return deck_extends.apply(this, arguments); }



var SvgDeck = function SvgDeck(props) {
  return /*#__PURE__*/react.createElement("svg", deck_extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), deck_path || (deck_path = /*#__PURE__*/react.createElement("path", {
    d: "M47.45 9.895c1.409 0 2.55 1.137 2.55 2.543v33.07a2.546 2.546 0 0 1-2.55 2.545H10.445a2.547 2.547 0 0 1-2.55-2.545l-.001-5.32a2.543 2.543 0 0 1 2.55-2.543h6.94v-6.92a2.547 2.547 0 0 1 2.55-2.542h6.62v-6.602a2.546 2.546 0 0 1 2.552-2.542h6.62v-6.601a2.546 2.546 0 0 1 2.552-2.543ZM31.365 2.482a1.66 1.66 0 0 1 2.37.031c.645.673.631 1.75-.032 2.404C23.146 15.351 13.084 25.55 3.353 35.421v10.931c0 .938-.752 1.7-1.677 1.7-.926 0-1.676-.762-1.676-1.7V34.717c0-.45.176-.883.491-1.203 9.893-10.032 20.122-20.408 30.875-31.032Z"
  })));
};

/* harmony default export */ var deck = (SvgDeck);
// EXTERNAL MODULE: ./public/static/icons/calendar.svg
var calendar = __webpack_require__(34275);
// EXTERNAL MODULE: ./public/static/icons/tour.svg
var tour = __webpack_require__(42392);
// EXTERNAL MODULE: ./public/static/icons/anchor.svg
var icons_anchor = __webpack_require__(60011);
;// CONCATENATED MODULE: ./public/static/icons/earth.svg
var earth_path;

function earth_extends() { earth_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return earth_extends.apply(this, arguments); }



var SvgEarth = function SvgEarth(props) {
  return /*#__PURE__*/react.createElement("svg", earth_extends({
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), earth_path || (earth_path = /*#__PURE__*/react.createElement("path", {
    d: "M42.624 7.313C47.34 12.03 49.938 18.3 49.938 24.97c0 6.67-2.598 12.94-7.314 17.655-4.716 4.716-10.986 7.314-17.655 7.314-6.67 0-12.94-2.598-17.656-7.314A24.805 24.805 0 0 1 0 24.97c0-6.67 2.597-12.94 7.313-17.656A24.806 24.806 0 0 1 24.97 0c6.67 0 12.94 2.597 17.655 7.313Zm-2.207 33.105a21.699 21.699 0 0 0 5.964-11.074c-.658.968-1.286 1.327-1.675-.839-.401-3.53-3.644-1.275-5.683-2.529-2.146 1.446-6.969-2.812-6.15 1.991 1.265 2.166 6.829-2.9 4.056 1.684-1.77 3.2-6.469 10.287-5.857 13.96.077 5.352-5.469 1.117-7.38-.659-1.285-3.556-.438-9.771-3.799-11.513-3.647-.158-6.778-.49-8.192-4.568-.85-2.918.905-7.261 4.032-7.932 4.577-2.875 6.212 3.368 10.504 3.484 1.333-1.395 4.965-1.838 5.266-3.402-2.816-.497 3.573-2.368-.27-3.432-2.12.25-3.485 2.198-2.358 3.85-4.108.959-4.24-5.944-8.189-3.767-.1 3.443-6.448 1.116-2.196.418 1.46-.638-2.383-2.488-.306-2.152 1.02-.055 4.454-1.258 3.525-2.067 1.912-1.187 3.519 2.842 5.39-.092 1.351-2.256-.567-2.673-2.26-1.53-.955-1.068 1.686-3.378 4.015-4.376.776-.332 1.518-.513 2.084-.462 1.174 1.355 3.343 1.59 3.457-.163a21.767 21.767 0 0 0-9.426-2.127c-4.76 0-9.289 1.513-13.036 4.31 1.007.462 1.579 1.037.608 1.77-.753 2.247-3.812 5.262-6.496 4.835a21.606 21.606 0 0 0-2.705 7.828c2.249.744 2.767 2.217 2.284 2.71-1.146.998-1.85 2.415-2.213 3.965.732 4.479 2.837 8.606 6.11 11.879a21.704 21.704 0 0 0 15.448 6.398 21.705 21.705 0 0 0 15.448-6.398Z"
  })));
};

/* harmony default export */ var earth = (SvgEarth);
;// CONCATENATED MODULE: ./public/static/icons/bord-language.svg
var bord_language_path;

function bord_language_extends() { bord_language_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return bord_language_extends.apply(this, arguments); }



var SvgBordLanguage = function SvgBordLanguage(props) {
  return /*#__PURE__*/react.createElement("svg", bord_language_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), bord_language_path || (bord_language_path = /*#__PURE__*/react.createElement("path", {
    d: "M44.17 17.313C47.163 20.063 49 23.814 49 27.95c0 4.79-2.473 9.077-6.345 11.881a9.572 9.572 0 0 0-.068 1.059c0 2.565 1.495 4.812 3.783 6.055v.992c-4.244-.109-8.145-.828-11.821-4.876-.87.119-1.759.185-2.669.185-3.931 0-7.548-1.189-10.442-3.175 5.954-.021 11.576-2.15 15.839-6 2.141-1.944 3.842-4.213 5.035-6.766a20.108 20.108 0 0 0 1.908-8.564c0-.48-.02-.959-.05-1.428zM19.907 2c10.992 0 19.907 7.726 19.907 17.257 0 9.54-8.915 17.267-19.907 17.267-1.054 0-2.087-.074-3.102-.211-4.276 4.56-9.21 5.383-14.145 5.5v-1.119c2.66-1.393 4.807-3.927 4.807-6.829 0-.412-.028-.803-.088-1.193C2.877 29.506 0 24.672 0 19.257 0 9.727 8.914 2 19.906 2z"
  })));
};

/* harmony default export */ var bord_language = (SvgBordLanguage);
;// CONCATENATED MODULE: ./src/components/atoms/label-icon/label-icon.tsx
















var LabelIcon = function LabelIcon(_ref) {
  var type = _ref.type,
      amount = _ref.amount,
      _ref$iconColor = _ref.iconColor,
      iconColor = _ref$iconColor === void 0 ? global_style/* theme.colors.main4 */.rS.colors.main4 : _ref$iconColor,
      _ref$fontColor = _ref.fontColor,
      fontColor = _ref$fontColor === void 0 ? global_style/* theme.shades.blackGrey */.rS.shades.blackGrey : _ref$fontColor,
      _ref$horizontal = _ref.horizontal,
      horizontal = _ref$horizontal === void 0 ? false : _ref$horizontal;
  var IconComponent = {
    // ship page
    buildYear: {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(yearbuilt, {}),
      label: 'shipLaunchDate'
    },
    passenger: {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(user_group, {}),
      label: 'shipPassengers'
    },
    crew: {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(crew, {}),
      label: 'shipCrew'
    },
    decks: {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(deck, {}),
      label: 'shipDecks'
    },
    // Cruiseline page
    ship: {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ship/* default */.Z, {}),
      label: 'cruiselineShips'
    },
    language: {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(bord_language, {}),
      label: 'cruiselineBoardLanguage'
    },
    newestShip: {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(yearbuilt, {}),
      label: 'cruiselineNewestShip'
    },
    destinations: {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(earth, {}),
      label: 'cruiselineDestinations'
    },
    //destination page
    harbours: {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_anchor/* default */.Z, {}),
      label: 'destinationHarbours'
    },
    routes: {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tour/* default */.Z, {}),
      label: 'destinationRoutes'
    },
    travelWindow: {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(calendar/* default */.Z, {}),
      label: 'travelWindow'
    },
    length: {
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ship/* default */.Z, {}),
      label: 'shipLength'
    }
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(label_icon_style_StyledContainer, {
    horizontal: horizontal,
    "data-testid": 'label-icon-component',
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledIconContainer, {
      iconColor: iconColor,
      horizontal: horizontal,
      children: IconComponent[type].icon
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledAmount, {
      horizontal: horizontal,
      fontColor: fontColor,
      iconType: type,
      children: amount
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLabel, {
      horizontal: horizontal,
      fontColor: fontColor,
      iconType: type,
      children: (0,translation_service.__)(IconComponent[type].label)
    })]
  });
};
// EXTERNAL MODULE: ./src/components/atoms/section-headline/section-headline.tsx
var section_headline = __webpack_require__(87080);
// EXTERNAL MODULE: ./src/components/atoms/simple-gallery/simple-gallery.tsx + 1 modules
var simple_gallery = __webpack_require__(11178);
// EXTERNAL MODULE: ./src/components/atoms/button/button.tsx
var button_button = __webpack_require__(88854);
// EXTERNAL MODULE: ./node_modules/@mui/material/ImageList/ImageList.js + 1 modules
var ImageList = __webpack_require__(65450);
// EXTERNAL MODULE: ./node_modules/@mui/material/ImageListItem/ImageListItem.js + 1 modules
var ImageListItem = __webpack_require__(89007);
// EXTERNAL MODULE: ./node_modules/@mui/material/ImageListItemBar/ImageListItemBar.js + 1 modules
var ImageListItemBar = __webpack_require__(59225);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/index.js + 8 modules
var dist = __webpack_require__(71227);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/styles.css
var styles = __webpack_require__(85737);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/fullscreen/index.js + 3 modules
var fullscreen = __webpack_require__(69178);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/index.js + 5 modules
var thumbnails = __webpack_require__(52806);
// EXTERNAL MODULE: ./node_modules/yet-another-react-lightbox/dist/plugins/thumbnails/thumbnails.css
var thumbnails_thumbnails = __webpack_require__(50925);
;// CONCATENATED MODULE: ./public/static/icons/lightboxgallery.svg
var lightboxgallery_path;

function lightboxgallery_extends() { lightboxgallery_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return lightboxgallery_extends.apply(this, arguments); }



var SvgLightboxgallery = function SvgLightboxgallery(props) {
  return /*#__PURE__*/react.createElement("svg", lightboxgallery_extends({
    width: 12,
    height: 13,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), lightboxgallery_path || (lightboxgallery_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.636.5h2.182c.904 0 1.637.733 1.637 1.636v2.182c0 .904-.733 1.637-1.637 1.637H1.636A1.636 1.636 0 0 1 0 4.318V2.136C0 1.233.733.5 1.636.5Zm6.546 0h2.182C11.267.5 12 1.233 12 2.136v2.182c0 .904-.733 1.637-1.636 1.637H8.182a1.636 1.636 0 0 1-1.637-1.637V2.136C6.545 1.233 7.278.5 8.182.5ZM3.818 7.045H1.636C.733 7.045 0 7.778 0 8.682v2.182c0 .903.733 1.636 1.636 1.636h2.182c.904 0 1.637-.733 1.637-1.636V8.682c0-.904-.733-1.637-1.637-1.637Zm4.364 0h2.182c.903 0 1.636.733 1.636 1.637v2.182c0 .903-.733 1.636-1.636 1.636H8.182a1.636 1.636 0 0 1-1.637-1.636V8.682c0-.904.733-1.637 1.637-1.637Z"
  })));
};

/* harmony default export */ var lightboxgallery = (SvgLightboxgallery);
;// CONCATENATED MODULE: ./src/components/atoms/lightbox-gallery/lightbox-gallery.style.tsx


function lightbox_gallery_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var StyledButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1rer8sg1"
} : 0)( true ? {
  name: "12aw3ut",
  styles: "position:absolute;width:100%;left:0;right:0;top:0"
} : 0);
var StyledLightboxGalleryIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(lightboxgallery,  true ? {
  target: "e1rer8sg0"
} : 0)( true ? {
  name: "sbfbu3",
  styles: "width:12px;margin-left:-4px;margin-right:10px;fill:currentColor"
} : 0);
;// CONCATENATED MODULE: ./src/components/atoms/lightbox-gallery/lightbox-gallery.tsx


function lightbox_gallery_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function lightbox_gallery_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? lightbox_gallery_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : lightbox_gallery_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var LightboxGallery = function LightboxGallery(_ref) {
  var _images$, _images$2, _images$3, _images$4, _images$5, _images$6;

  var images = _ref.images;

  var _useState = (0,react.useState)(-1),
      index = _useState[0],
      setIndex = _useState[1]; // to modify the size and the view of the images


  var srcset = function srcset(image, _size) {
    var _rows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    var _cols = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    return {
      src: "".concat(image),
      srcSet: "".concat(image, " 2x")
    };
  };

  var galleryThumbnails = [{
    img: (_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.src,
    title: (_images$2 = images[0]) === null || _images$2 === void 0 ? void 0 : _images$2.alt,
    rows: 2,
    cols: 2,
    index: 0
  }, {
    img: (_images$3 = images[1]) === null || _images$3 === void 0 ? void 0 : _images$3.src,
    title: (_images$4 = images[1]) === null || _images$4 === void 0 ? void 0 : _images$4.alt,
    index: 1
  }, {
    img: (_images$5 = images[2]) === null || _images$5 === void 0 ? void 0 : _images$5.src,
    title: (_images$6 = images[2]) === null || _images$6 === void 0 ? void 0 : _images$6.alt,
    index: 2
  }];
  var showGalleryThumbnails = images.length >= 3;
  var slides = images.map(function (image) {
    return {
      src: image.src,
      alt: image.alt,
      placeholder: image.placeholder
    };
  });
  if ((images === null || images === void 0 ? void 0 : images.length) === 0) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ImageList/* default */.Z, {
    variant: "quilted",
    cols: showGalleryThumbnails ? 3 : 1,
    gap: 9,
    rowHeight: 200,
    children: [(showGalleryThumbnails ? galleryThumbnails : [galleryThumbnails[0]]).map(function (item) {
      if (!item.img) {
        return null;
      }

      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ImageListItem/* default */.Z, {
        cols: item.cols || 1,
        rows: item.rows || 1,
        style: {
          cursor: 'pointer'
        },
        onClick: function onClick() {
          return setIndex(item.index);
        },
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", lightbox_gallery_objectSpread(lightbox_gallery_objectSpread({}, srcset(item.img, 200, item.rows, item.cols)), {}, {
          alt: item.title,
          loading: "lazy"
        })), item.index === 2 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageListItemBar/* default */.Z, {
          sx: {
            position: 'absolute',
            top: '50%',
            marginTop: '-22px',
            height: '44px',
            textAlign: 'center',
            background: 'transparent'
          },
          actionIcon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(button_button/* Button */.z, {
              variant: "outlined",
              onClick: function onClick() {
                return setIndex(item.index);
              },
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLightboxGalleryIcon, {}), (0,translation_service.__)('viewAllPhotos')]
            })
          })
        })]
      }, item.img);
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* default */.Z, {
      open: index >= 0,
      index: index,
      close: function close() {
        return setIndex(-1);
      },
      slides: slides,
      carousel: {
        finite: !showGalleryThumbnails
      },
      plugins: [fullscreen/* default */.Z, thumbnails/* default */.Z]
    })]
  });
};
// EXTERNAL MODULE: ./public/static/icons/star.svg
var star = __webpack_require__(95559);
;// CONCATENATED MODULE: ./src/components/atoms/suggestion-box/suggestion-box.style.tsx




var StyledSuggestionBoxWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewsobhj6"
} : 0)("color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";border:1px solid rgba(151, 151, 151, 0.5);height:100%;" + ( true ? "" : 0));
var StyledHeadlineBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewsobhj5"
} : 0)("background-color:", function (props) {
  return props.background;
}, ";display:flex;" + ( true ? "" : 0));
var suggestion_box_style_StyledIconBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewsobhj4"
} : 0)("background-color:", function (props) {
  return props.background;
}, ";display:flex;align-items:center;justify-content:center;min-height:40px;flex-basis:", function (props) {
  return props.type === 'exclusive' ? '40px' : '60px';
}, ";flex-grow:0;flex-shrink:0;position:relative;", function (props) {
  return props.type === 'suggestion' ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("svg{margin-left:-10px;}&:after{content:'';border-style:solid;border-width:20px 10px 20px 0px;border-color:transparent ", props.theme.colors['main2-20'], " transparent transparent;position:absolute;right:-1px;top:0px;}" + ( true ? "" : 0),  true ? "" : 0) : null;
}, ";" + ( true ? "" : 0));
var StyledHeadline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h4",  true ? {
  target: "ewsobhj3"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";font-weight:700;margin:0;padding:0;flex-grow:1;text-align:center;align-self:center;" + ( true ? "" : 0));
var StyledTextBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ewsobhj2"
} : 0)("text-align:center;padding:15px;p{font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";}" + ( true ? "" : 0));
var StyledStarSvg = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(star/* default */.Z,  true ? {
  target: "ewsobhj1"
} : 0)("height:21px;width:21px;fill:", function (props) {
  return props.theme.shades.white;
}, ";" + ( true ? "" : 0));
var StyledLightBulbSvg = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(lightingbulb,  true ? {
  target: "ewsobhj0"
} : 0)("height:21px;width:21px;fill:", function (props) {
  return props.theme.shades.white;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/components/atoms/suggestion-box/suggestion-box.tsx





var SuggestionBox = function SuggestionBox(_ref) {
  var type = _ref.type,
      text = _ref.text,
      _ref$headline = _ref.headline,
      headline = _ref$headline === void 0 ? 'Unser Dreamlines Experten-Tipp' : _ref$headline;
  var content = {
    suggestion: {
      headlineBg: global_style/* theme.colors.main2-20 */.rS.colors["main2-20"],
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLightBulbSvg, {}),
      iconBg: global_style/* theme.colors.main2 */.rS.colors.main2
    },
    exclusive: {
      headlineBg: global_style/* theme.colors.discountSpecial-20 */.rS.colors["discountSpecial-20"],
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledStarSvg, {}),
      iconBg: global_style/* theme.colors.discountSpecial */.rS.colors.discountSpecial
    }
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSuggestionBoxWrapper, {
    "data-testid": "suggestion-box",
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledHeadlineBox, {
      background: content[type].headlineBg,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(suggestion_box_style_StyledIconBox, {
        background: content[type].iconBg,
        type: type,
        children: content[type].icon
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHeadline, {
        "data-testid": "suggestion-box-headline",
        children: headline
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTextBox, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
        children: text
      })
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/react-swipeable-views/lib/index.js
var lib = __webpack_require__(77314);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tabs/Tabs.js + 8 modules
var Tabs = __webpack_require__(11703);
// EXTERNAL MODULE: ./node_modules/@mui/material/Tab/Tab.js + 1 modules
var Tab = __webpack_require__(40044);
;// CONCATENATED MODULE: ./src/components/atoms/tab-container/tab-container.style.tsx


function tab_container_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var StyledTabComponent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ecojkf22"
} : 0)("color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";.MuiTab-wrapper{font-size:", function (props) {
  return props.theme.fontSize.copyTextXL;
}, ";}&& .MuiTabs-scroller.MuiTabs-fixed{overflow:visible!important;}.MuiTab-fullWidth{border-bottom:1px solid ", function (props) {
  return props.theme.shades.lightMidGrey;
}, ";}" + ( true ? "" : 0));
var StyledTabInner = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ecojkf21"
} : 0)("margin:", function (props) {
  return props.isSingleView ? '10px 0' : '20px 0';
}, ";font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";" + ( true ? "" : 0));
var StyledNonTabHeadline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "ecojkf20"
} : 0)( true ? {
  name: "1v0ecl9",
  styles: "font-size:15px;font-weight:700;margin:30px 0 0"
} : 0);
;// CONCATENATED MODULE: ./src/components/atoms/tab-container/tab-container.tsx








var TabContainer = function TabContainer(_ref) {
  var items = _ref.items;

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      view = _React$useState2[0],
      setView = _React$useState2[1]; // tslint:disable-next-line: variable-name


  var handleChange = function handleChange(_event, newValue) {
    setView(newValue);
  };

  var isSingleView = items.length === 1 ? true : false;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledTabComponent, {
    children: [isSingleView ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledNonTabHeadline, {
      children: items[0][0]
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs/* default */.Z, {
      value: view,
      onChange: handleChange,
      variant: 'fullWidth',
      children: items.map(function (item) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab/* default */.Z, {
          label: item[0]
        }, item[0]);
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib/* default */.ZP, {
      index: view,
      onChangeIndex: function onChangeIndex(index) {
        return setView(index);
      },
      children: items.map(function (item) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTabInner, {
          isSingleView: isSingleView,
          children: item[1]
        }, item[0]);
      })
    })]
  });
};
// EXTERNAL MODULE: ./src/components/molecules/modal/modal.tsx + 1 modules
var modal = __webpack_require__(52753);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js
var SvgIcon = __webpack_require__(2373);
;// CONCATENATED MODULE: ./public/static/icons/enlarge.svg
var enlarge_path;

function enlarge_extends() { enlarge_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return enlarge_extends.apply(this, arguments); }



var SvgEnlarge = function SvgEnlarge(props) {
  return /*#__PURE__*/react.createElement("svg", enlarge_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), enlarge_path || (enlarge_path = /*#__PURE__*/react.createElement("path", {
    d: "M32 32.033V20.388l-3.497 3.497-5.219-5.219-4.638 4.638 5.219 5.219-3.51 3.51H32zM0 32.033h11.645l-3.497-3.497 5.219-5.219-4.638-4.638-5.219 5.219-3.503-3.51L0 32.033zM0 0v11.645l3.497-3.497 5.219 5.219 4.638-4.638L8.135 3.51 11.645 0H0zM32 .007H20.355l3.497 3.497-5.219 5.219 4.638 4.638 5.219-5.219 3.51 3.51V.007z"
  })));
};

/* harmony default export */ var enlarge = (SvgEnlarge);
// EXTERNAL MODULE: ./public/static/arrow.svg
var arrow = __webpack_require__(59846);
;// CONCATENATED MODULE: ./src/components/sections/overview/overview.style.tsx



var overview_style_excluded = (/* unused pure expression or super */ null && (["isCollapsed"]));

function overview_style_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function overview_style_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? overview_style_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : overview_style_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function overview_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }







// I know, I'm sad too
var StyledOuterWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1xuaznv22"
} : 0)( true ? "" : 0);
var StyledInnerWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv21"
} : 0)("color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";background-color:", function (props) {
  return props.theme.shades.white;
}, ";padding:0 10px;margin:0 auto;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{margin:0 15px 15px 15px;padding:0 10px 20px 10px;display:flex;flex-direction:column;}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{max-width:calc(100% - 30px);padding:20px 10px 30px;margin:0 auto;margin-bottom:20px;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{max-width:1170px;padding:20px 30px 30px;margin:0 auto;margin-bottom:20px;}" + ( true ? "" : 0));
var StyledSubHeadline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h3",  true ? {
  target: "e1xuaznv20"
} : 0)("font-size:15px;font-weight:700;line-height:21px;margin:0;display:block;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.copyTextXL;
}, ";padding-bottom:15px;font-size:", function (props) {
  return props.theme.fontSize.headlineS;
}, ";}" + ( true ? "" : 0));
var overview_style_StyledText = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv19"
} : 0)("margin:0;width:100%;padding:20px 0;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{padding:30px 0;}" + ( true ? "" : 0));
var StyledParagraph = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("p",  true ? {
  target: "e1xuaznv18"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";line-height:22px;margin-top:0;margin-bottom:0;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";line-height:21px;}" + ( true ? "" : 0));
var StyledGalleryContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv17"
} : 0)("padding:22px 0;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{width:100%;}" + ( true ? "" : 0));
var StyledRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv16"
} : 0)("@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{display:flex;}" + ( true ? "" : 0));
var StyledButtonContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv15"
} : 0)("display:flex;justify-content:center;padding-bottom:10px;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{display:none;}" + ( true ? "" : 0));
var StyledLabelIconContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv14"
} : 0)("display:none;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{padding:10px 15px 15px 0;margin-left:15px;display:block;background-color:", function (props) {
  return props.theme.labels.onlineBookable;
}, ";width:100%;max-width:calc(100% - 30px);}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{max-width:calc(100% - 30px);margin:0 auto;padding-left:15px;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{max-width:1170px;}" + ( true ? "" : 0));
var StyledLabelIconModalContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv13"
} : 0)( true ? {
  name: "1a613cs",
  styles: "padding:20px 0px 10px 0"
} : 0);
var StyledLabelIconList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1xuaznv12"
} : 0)("display:flex;justify-content:space-evenly;list-style:none;padding-left:10px;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{justify-content:flex-start;padding-left:10px;}" + ( true ? "" : 0));
var StyledLabelIconItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "e1xuaznv11"
} : 0)("width:100%;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{width:25%;span{font-size:18px;}}" + ( true ? "" : 0));
var StyledHighlightsContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv10"
} : 0)("display:none;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{width:100%;display:block;padding:22px 0;}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{max-width:470px;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{max-width:527px;}" + ( true ? "" : 0));
var StyledHighlightsList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "e1xuaznv9"
} : 0)("padding-left:0;li{font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";line-height:22px;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";line-height:21px;width:50%;}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{max-width:470px;width:33%;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{padding-left:10px;span{font-size:15px;}}}" + ( true ? "" : 0));
var StyledSuggestionBoxContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv8"
} : 0)("width:100%;margin-bottom:30px;&+&{margin-left:30px;}display:", function (props) {
  return props.showOnMobile ? 'block' : 'none';
}, ";@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{display:block;margin-bottom:0;}" + ( true ? "" : 0));
var StyledImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "e1xuaznv7"
} : 0)( true ? {
  name: "w1atjl",
  styles: "width:100%;height:100%"
} : 0);
var StyledImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv6"
} : 0)( true ? {
  name: "1cwloic",
  styles: "width:100%;overflow:hidden"
} : 0);

var enlargeIcon = function enlargeIcon(props) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, overview_style_objectSpread(overview_style_objectSpread({}, props), {}, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(enlarge, {})
  }));
};

var StyledEnlargedIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(enlargeIcon,  true ? {
  target: "e1xuaznv5"
} : 0)( true ? {
  name: "1m839ek",
  styles: "position:absolute;right:5px;width:25px;height:25px"
} : 0);
var StyledAspectRatio = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv4"
} : 0)("position:relative;&::before{position:relative;display:block;content:'';padding-bottom:calc(225 / 350 * 100%);@media ", global_style/* mediaQueries.tablet */.w5.tablet, "{padding-bottom:calc(263 / 350 * 100%);}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{padding-bottom:calc(263 / 527 * 100%);}}" + ( true ? "" : 0));
var StyledContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv3"
} : 0)( true ? {
  name: "lol706",
  styles: "position:absolute;top:0;bottom:0;left:0;right:0;overflow:hidden"
} : 0);
var StyledShowMoreBtn = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("button",  true ? {
  target: "e1xuaznv2"
} : 0)("background-color:", function (props) {
  return props.theme.shades.white;
}, ";color:", function (props) {
  return props.theme.colors.main4;
}, ";font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";font-weight:700;font-style:normal;font-stretch:normal;line-height:normal;letter-spacing:normal;padding:15px 0 15px 0;margin:0;display:flex;align-items:center;justify-content:center;border:none;width:100%;@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{display:none;}" + ( true ? "" : 0));
var StyledHighlightWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1xuaznv1"
} : 0)("background-color:", function (props) {
  return props.theme.shades.white;
}, ";padding:0;@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{padding:20px 0;}" + ( true ? "" : 0));
var StyledArrowIcon = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled(function (_ref) {
  var isCollapsed = _ref.isCollapsed,
      rest = _objectWithoutProperties(_ref, overview_style_excluded);

  return _jsx(ArrowSVG, overview_style_objectSpread({}, rest));
},  true ? {
  target: "e1xuaznv0"
} : 0)("width:12px;height:12px;margin-left:5px;stroke-width:2;fill:", function (props) {
  return props.theme.colors.main4;
}, ";transform:", function (props) {
  return props.isCollapsed ? "rotate(90deg)" : "rotate(-90deg)";
}, ";" + ( true ? "" : 0))));
;// CONCATENATED MODULE: ./src/components/sections/overview/overview.tsx
























var Overview = function Overview(_ref) {
  var title = _ref.title,
      headline = _ref.headline,
      subHeadline1 = _ref.subHeadline1,
      buttonLabel = _ref.buttonLabel,
      descriptionPoints = _ref.descriptionPoints,
      icons = _ref.icons,
      boxes = _ref.boxes,
      images = _ref.images,
      highlights = _ref.highlights,
      description = _ref.description;

  var _React$useState = react.useState(false),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      isOpen = _React$useState2[0],
      setIsOpen = _React$useState2[1];

  var handleOpenModal = function handleOpenModal() {
    setIsOpen(true);
  };

  var handleCloseModal = function handleCloseModal() {
    setIsOpen(false);
  };

  var isMobile = (0,device_detection/* getDetectedDevice */.c)() === 'mobile';

  var _useState = (0,react.useState)(-1),
      index = _useState[0],
      setIndex = _useState[1];

  var slides = images.map(function (image) {
    return {
      src: image.src,
      alt: image.alt,
      placeholder: image.placeholder
    };
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledOuterWrapper, {
    "data-testid": 'overview-component',
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(section_headline/* SectionHeadline */.A, {
      firstChunk: title,
      secondChunk: headline
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLabelIconContainer, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLabelIconList, {
        children: icons.map(function (icon) {
          var amount = typeof icon.amount === 'number' && icon.type !== 'buildYear' && icon.type !== 'newestShip' ? (0,formatting/* numberFormat */.Y4)(icon.amount) : icon.amount;
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLabelIconItem, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelIcon, {
              type: icon.type,
              amount: amount,
              iconColor: global_style/* theme.shades.white */.rS.shades.white,
              fontColor: global_style/* theme.shades.white */.rS.shades.white
            }, icon.type)
          }, icon.type + icon.amount);
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledInnerWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHighlightsList, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHighlightWrapper, {
          children: highlights
        })
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledInnerWrapper, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledRow, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledGalleryContainer, {
          children: isMobile ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(simple_gallery/* SimpleGallery */.P, {
            showShadow: true,
            children: images.map(function (image, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImageWrapper, {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledAspectRatio, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContentWrapper, {
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(image_image/* NextImage */.o, {
                      alt: image.alt,
                      imgUrl: image.src,
                      width: image.width,
                      height: image.height,
                      placeholder: image.placeholder,
                      containerHeight: "100%"
                    })
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
                    excludeArrow: true,
                    disabled: true,
                    tertiary: true,
                    style: {
                      borderColor: 'transparent',
                      color: global_style/* theme.shades.white */.rS.shades.white,
                      marginTop: '-40px',
                      position: 'absolute',
                      right: '5px'
                    },
                    onClick: function onClick() {
                      return setIndex(index);
                    },
                    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledEnlargedIcon, {})
                  })]
                })
              }, "".concat(image, "-").concat(index));
            })
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LightboxGallery, {
            images: images
          })
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist/* default */.Z, {
          open: index >= 0,
          index: index,
          close: function close() {
            return setIndex(-1);
          },
          slides: slides,
          plugins: [thumbnails/* default */.Z]
        })]
      }), description && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledRow, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(overview_style_StyledText, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSubHeadline, {
            children: subHeadline1
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            dangerouslySetInnerHTML: {
              __html: description
            }
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledRow, {
        children: boxes === null || boxes === void 0 ? void 0 : boxes.map(function (box) {
          return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSuggestionBoxContainer, {
            showOnMobile: box.showOnMobile,
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SuggestionBox, {
              type: box.type,
              headline: box.headline,
              text: box.text
            })
          }, box.text);
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledButtonContainer, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
          style: {
            color: global_style/* theme.colors.main4 */.rS.colors.main4,
            borderColor: global_style/* theme.colors.main4 */.rS.colors.main4,
            backgroundColor: 'transparent'
          },
          tertiary: true,
          onClick: handleOpenModal,
          children: buttonLabel
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(modal/* Modal */.u, {
        showModal: isOpen,
        onClose: handleCloseModal,
        headerText: headline,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLabelIconModalContainer, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledLabelIconList, {
            children: icons.map(function (icon) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LabelIcon, {
                  type: icon.type,
                  amount: icon.amount,
                  iconColor: global_style/* theme.colors.main4 */.rS.colors.main4,
                  fontColor: global_style/* theme.shades.blackGrey */.rS.shades.blackGrey,
                  horizontal: true
                })
              }, icon.type + icon.amount);
            })
          })
        }), descriptionPoints && boxes !== null && boxes !== void 0 && boxes.length ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabContainer, {
          items: [[(0,translation_service.__)('highlights'), // eslint-disable-next-line react/jsx-key
          (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHighlightsList, {
            children: descriptionPoints === null || descriptionPoints === void 0 ? void 0 : descriptionPoints.map(function (item) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: item
              }, item);
            })
          })], [(0,translation_service.__)('expertTip'), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
            children: boxes === null || boxes === void 0 ? void 0 : boxes.map(function (box) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconTextbox, {
                text: box.text
              }, box.text);
            })
          })]]
        }) : (descriptionPoints === null || descriptionPoints === void 0 ? void 0 : descriptionPoints.length) && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabContainer, {
          items: [[(0,translation_service.__)('highlights'), // eslint-disable-next-line react/jsx-key
          (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledHighlightsList, {
            children: descriptionPoints === null || descriptionPoints === void 0 ? void 0 : descriptionPoints.map(function (item, index) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("li", {
                children: item
              }, item + index);
            })
          })]]
        })]
      })]
    })]
  });
};
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(16645);
;// CONCATENATED MODULE: ./src/modules/overview-mod.tsx


function overview_mod_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function overview_mod_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? overview_mod_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : overview_mod_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }











var OverviewMod = function OverviewMod(_ref) {
  var getLandingPage = _ref.getLandingPage,
      modulesData = _ref.modulesData;
  var data = modulesData["".concat(getLandingPage.type).concat(getLandingPage.id)];
  var props = {};

  switch (getLandingPage.type) {
    case 'ship':
      {
        props = shipData(data);
        break;
      }
    // we don't use below cases like 'destination' and 'cruiseline' maybe we should remove them

    case 'destination':
      {
        props = destinationData(data, modulesData);
        break;
      }

    case 'cruiseline':
      {
        props = cruiselineData(data);
        break;
      }
  }

  var title = "".concat(getLandingPage !== null && getLandingPage !== void 0 && getLandingPage.title ? getLandingPage.title : '');

  if (!data || !data.highlights) {
    return null;
  }

  var labels = groupLabels(data.highlights);
  var highlights = labels !== null && labels !== void 0 && labels.length ? [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(highlights_style/* StyledHighlightInnerWrapper */.Ej, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconList, {
      color: global_style/* theme.labels.onlineBookable */.rS.labels.onlineBookable,
      labels: labels,
      icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(highlights_style/* CheckMarkIcon */.Ol, {})
    })
  }, "highlights-list")] : [];
  var isDesktop = (0,device_detection/* getDetectedDevice */.c)() === 'desktop';
  var subHeadline1 = isDesktop ? "".concat((0,translation_service.__)('Cruises with %s (ship page)').replace('%s', title)) : "".concat(title, " - ").concat((0,translation_service.__)('Ship impression'));
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overview, overview_mod_objectSpread({
      title: title,
      headline: "".concat((0,translation_service.__)('overviewHeadline')),
      subHeadline1: subHeadline1,
      buttonLabel: (0,translation_service.__)('overviewButton'),
      descriptionPoints: data !== null && data !== void 0 && data.descriptionPoints ? data.descriptionPoints : null,
      highlights: highlights,
      description: data.seoText
    }, props), "overview")
  });
};

var shipData = function shipData(data) {
  var text = data !== null && data !== void 0 && data.teaserDescription ? data.teaserDescription : '';
  var icons = [];
  var images = [];

  if (data !== null && data !== void 0 && data.factsAndFigures) {
    var _data$images;

    var _data$factsAndFigures = data.factsAndFigures,
        manufactureYear = _data$factsAndFigures.manufactureYear,
        passengerCapacity = _data$factsAndFigures.passengerCapacity,
        crewMembers = _data$factsAndFigures.crewMembers,
        decks = _data$factsAndFigures.decks;

    if (manufactureYear) {
      icons.push({
        type: 'buildYear',
        amount: manufactureYear
      });
    }

    if (passengerCapacity) {
      icons.push({
        type: 'passenger',
        amount: passengerCapacity
      });
    }

    if (crewMembers) {
      icons.push({
        type: 'crew',
        amount: crewMembers
      });
    }

    if (decks) {
      icons.push({
        type: 'decks',
        amount: decks
      });
    }

    if (data !== null && data !== void 0 && (_data$images = data.images) !== null && _data$images !== void 0 && _data$images.length) {
      images = data.images.map(function (item) {
        return {
          src: item.image.url,
          alt: data.title,
          placeholder: item.thumb.url,
          width: item.image.width,
          height: item.image.height
        };
      });
      images = images.slice(0, 10);
    }
  }

  return {
    text: text,
    images: images,
    icons: icons
  };
};

var destinationData = function destinationData(data, modulesData) {
  var _harbourSearch$items$, _harbourSearch$items$2, _data$images2;

  var text = data !== null && data !== void 0 && data.teaserDescription ? data.teaserDescription : '';
  var icons = [];
  var images = [];
  var cruiseSearch = modulesData['cruiseSearchlandingpageOverview'];
  var routes = cruiseSearch.totalCount ? cruiseSearch.totalCount : null;
  var harbourSearch = modulesData['harbourSearchharbourTeaser'];
  var harbours = harbourSearch === null || harbourSearch === void 0 ? void 0 : harbourSearch.totalCount;
  var topMonth = harbourSearch === null || harbourSearch === void 0 ? void 0 : (_harbourSearch$items$ = harbourSearch.items[0]) === null || _harbourSearch$items$ === void 0 ? void 0 : (_harbourSearch$items$2 = _harbourSearch$items$.regions[0]) === null || _harbourSearch$items$2 === void 0 ? void 0 : _harbourSearch$items$2.topMonth;
  var travelWindow = topMonth ? (0,date/* getTranslatedMonth */.A2)(topMonth) : null;

  if (harbours) {
    icons.push({
      type: 'harbours',
      amount: harbours
    });
  }

  if (routes) {
    icons.push({
      type: 'routes',
      amount: routes
    });
  }

  if (travelWindow) {
    icons.push({
      type: 'travelWindow',
      amount: travelWindow
    });
  }

  if (data !== null && data !== void 0 && (_data$images2 = data.images) !== null && _data$images2 !== void 0 && _data$images2.length) {
    images = data.images.map(function (item) {
      return {
        src: item.url[0],
        alt: data.title,
        placeholder: item.url[1]
      };
    });
    images = images.slice(0, 10);
  }

  return {
    text: text,
    images: images,
    icons: icons
  };
};

var cruiselineData = function cruiselineData(data) {
  var _data$images3;

  var text = data !== null && data !== void 0 && data.teaserDescription ? data.teaserDescription : '';
  var icons = [];
  var images = [];
  var ships = data.brand.numberOfShips;
  var boardLanguage = data.boardLanguages ? data.boardLanguages[0] : null;
  var newestShip = data.newestShip ? data.newestShip : null;
  var destinations = data.brand.regionNames ? data.brand.regionNames.length : null;

  if (ships) {
    icons.push({
      type: 'ship',
      amount: ships
    });
  }

  if (boardLanguage) {
    icons.push({
      type: 'language',
      amount: boardLanguage
    });
  }

  if (newestShip) {
    icons.push({
      type: 'newestShip',
      amount: newestShip
    });
  }

  if (destinations) {
    icons.push({
      type: 'destinations',
      amount: destinations
    });
  }

  if (data !== null && data !== void 0 && (_data$images3 = data.images) !== null && _data$images3 !== void 0 && _data$images3.length) {
    images = data.images.map(function (item) {
      return {
        src: item.url[0],
        alt: data.title,
        placeholder: item.url[1]
      };
    });
    images = images.slice(0, 10);
  }

  return {
    text: text,
    images: images,
    icons: icons
  };
};

var groupLabels = function groupLabels(labels) {
  if (!labels.length || labels.length < 3) return null; // Show only first three items in scope of this task DREAM-16359

  return labels.slice(0, 3);
};
// EXTERNAL MODULE: ./src/components/atoms/dreamlines-button/dreamlines-button.style.tsx
var dreamlines_button_style = __webpack_require__(35246);
;// CONCATENATED MODULE: ./src/components/sections/horizontal-content-module/horizontal-content-item/horizontal-content-item.style.tsx


function horizontal_content_item_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var StyledContentArticle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "em7o6mh6"
} : 0)("margin-bottom:15px;&:last-child{margin-bottom:0;}@media ", global_style/* mediaQueries.phone */.w5.phone, "{padding-bottom:15px;border-bottom:1px solid ", function (props) {
  return props.theme.shades.lightGrey;
}, ";&:last-child{border-bottom:0;padding-bottom:0;}}@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{margin-bottom:", function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return fullWidth ? '35px' : '50px';
}, ";}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{margin-bottom:", function (_ref3) {
  var fullWidth = _ref3.fullWidth;
  return fullWidth ? '35px' : '80px';
}, ";}button{text-align:left;padding:0;background:none;border:0;outline:none;width:100%;}", dreamlines_button_style/* StyledRightArrowIcon */.el, "{fill:", function (props) {
  return props.theme.colors.main4;
}, ";right:0;}" + ( true ? "" : 0));
var horizontal_content_item_style_StyledContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "em7o6mh5"
} : 0)("@media ", global_style/* mediaQueries.phone */.w5.phone, "{display:flex;}@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{margin-bottom:20px;}&:after{content:'';clear:both;display:table;}" + ( true ? "" : 0));
var StyledDescription = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "em7o6mh4"
} : 0)(function (_ref4) {
  var cropText = _ref4.cropText;
  return cropText && /*#__PURE__*/css("@media ", mediaQueries.phone, "{overflow:hidden;text-overflow:ellipsis;-webkit-line-clamp:5;-webkit-box-orient:vertical;display:-webkit-box;width:90%;}" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0))));
var horizontal_content_item_style_StyledContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "em7o6mh3"
} : 0)("position:relative;width:100%;@media ", global_style/* mediaQueries.phone */.w5.phone, "{padding-left:", function (_ref5) {
  var fullWidth = _ref5.fullWidth;
  return fullWidth ? '0' : '15px';
}, ";width:", function (_ref6) {
  var fullWidth = _ref6.fullWidth;
  return fullWidth ? 'auto' : 'calc(100% - 130px)';
}, ";}", dreamlines_button_style/* StyledRightArrowIcon */.el, "{display:none;@media ", global_style/* mediaQueries.phone */.w5.phone, "{display:block;top:50%;transform:translateY(-50%);}}h4{margin:0 0 10px;padding-right:20px;font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";font-weight:bold;word-break:break-word;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";line-height:1.5;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.headlineXS;
}, ";}}p,li{padding:0;margin:0;font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";line-height:21px;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";}}ul{padding-left:20px;overflow:auto;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{padding-right:20px;}" + ( true ? "" : 0));
var StyledContentImage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "em7o6mh2"
} : 0)("@media ", global_style/* mediaQueries.phone */.w5.phone, "{width:", function (_ref7) {
  var fullWidth = _ref7.fullWidth;
  return fullWidth ? 'auto' : '130px';
}, ";}img{height:145px;object-fit:cover;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{width:100%;height:auto;object-fit:initial;}}" + ( true ? "" : 0));

var horizontal_content_item_style_ref =  true ? {
  name: "f7ay7b",
  styles: "justify-content:center"
} : 0;

var StyledContentLinksWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "em7o6mh1"
} : 0)("display:none;&>a{font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";font-weight:600;color:", function (props) {
  return props.theme.colors.main4;
}, ";text-decoration:none;position:relative;display:inline-block;margin-bottom:15px;", dreamlines_button_style/* StyledRightArrowIcon */.el, "{width:9px;height:10px;margin-left:5px;right:auto;position:relative;}@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{width:50%;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{width:25%;}}@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{display:flex;flex-wrap:wrap;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{justify-content:flex-start;text-align:center;", function (props) {
  return props.alignLinksCenter && horizontal_content_item_style_ref;
}, ";}" + ( true ? "" : 0)); // design the appearance of copy content module inside modal

var StyledContentItemOverlayWrapper = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "em7o6mh0"
} : 0)("max-height:100vh;overflow:auto;padding-bottom:40px;", horizontal_content_item_style_StyledContentWrapper, "{display:block;img{width:100%;height:auto;object-fit:initial;}}", StyledContentImage, "{width:100%;}", StyledContentLinksWrapper, "{display:block;padding:0 15px 50px;a{display:block;svg{top:2px;}}}h3{font-size:22px;font-weight:600;}", horizontal_content_item_style_StyledContent, "{margin:10px 0 30px 0;padding:0 15px;width:100%;", StyledRightArrowIcon, "{display:none;}}", StyledDescription, "{width:auto;}" + ( true ? "" : 0))));
// EXTERNAL MODULE: ./src/components/atoms/section-headline/section-headline.style.tsx
var section_headline_style = __webpack_require__(48957);
;// CONCATENATED MODULE: ./src/components/sections/horizontal-content-module/horizontal-content-module.style.tsx




var StyledContentModuleSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e3ver592"
} : 0)("max-width:1200px;margin:0px auto;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{padding:0 15px;}article:nth-of-type(odd){", StyledContentImage, "{@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{width:50%;float:left;padding-right:20px;}}}article:nth-of-type(even){", StyledContentImage, "{@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{float:right;padding-right:10px;padding-left:20px;width:calc(50% + 20px);}}", horizontal_content_item_style_StyledContentWrapper, "{@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{flex-direction:row-reverse;}}}" + ( true ? "" : 0));
var StyledContentItemsWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3ver591"
} : 0)("background:", function (props) {
  return props.theme.shades.white;
}, ";padding:20px 15px;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{padding:45px 20px;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{padding:45px 50px;}" + ( true ? "" : 0));
var StyledSectionHeadlineWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e3ver590"
} : 0)(section_headline_style/* StyledHeader */.e, "{@media ", global_style/* mediaQueries.phone */.w5.phone, "{padding-bottom:5px!important;}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/modules/ship-amenities-mod.tsx









var SeoWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1os6a830"
} : 0)("max-width:1170px;padding:20px 30px 30px;margin:0 auto;margin-bottom:20px;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";padding:20px 15px;font-size:15px;background-color:", function (props) {
  return props.theme.shades.white;
}, ";@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{padding:45px 20px;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{padding:45px 50px;}h2{margin:40px 0 15px;text-align:center;font-weight:bolder;font-size:25px;}p{margin:10px 0;}" + ( true ? "" : 0));

var ShipAmenitiesMod = function ShipAmenitiesMod(_ref) {
  var getLandingPage = _ref.getLandingPage,
      modulesData = _ref.modulesData;

  if (!modulesData) {
    return null;
  }

  var shipData = modulesData["ship".concat(getLandingPage.id)];

  if (!(shipData !== null && shipData !== void 0 && shipData.seoTextBottom)) {
    return null;
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledSectionHeadlineWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(section_headline/* SectionHeadline */.A, {
        firstChunk: shipData.title,
        secondChunk: (0,translation_service.__)('amenities')
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SeoWrapper, {
      dangerouslySetInnerHTML: {
        __html: shipData.seoTextBottom
      }
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82580);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var es = __webpack_require__(74231);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(21214);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(48263);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@mui/material/FormHelperText/FormHelperText.js
var FormHelperText = __webpack_require__(74509);
// EXTERNAL MODULE: ./src/components/atoms/input/input.tsx + 1 modules
var input = __webpack_require__(64182);
// EXTERNAL MODULE: ./src/components/atoms/input-label/input-label.tsx + 1 modules
var input_label = __webpack_require__(89675);
// EXTERNAL MODULE: ./src/components/atoms/form-control/form-control.tsx
var form_control = __webpack_require__(85100);
// EXTERNAL MODULE: ./src/components/molecules/phone-input/phone-input.tsx + 1 modules
var phone_input = __webpack_require__(50934);
// EXTERNAL MODULE: ./public/static/icons/checkmark-plain.svg
var checkmark_plain = __webpack_require__(44455);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/svgIconClasses.js
var svgIconClasses = __webpack_require__(62994);
;// CONCATENATED MODULE: ./src/components/sections/ship-contact-form/ship-contact-form.style.tsx


function ship_contact_form_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var StyledContactFormHeader = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "es9w14z4"
} : 0)("font-size:28px;font-style:normal;font-weight:700;line-height:44px;margin:0;color:", function (props) {
  return props.theme.colorsUnifications.gunmetal[100];
}, ";" + ( true ? "" : 0));
var StyledContactDirectly = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "es9w14z3"
} : 0)("height:100%;background-color:", function (props) {
  return props.theme.colorsUnifications.azure[100];
}, ";padding:24px 16px;", StyledContactFormHeader, "{color:#fff;margin-bottom:24px;", function (props) {
  return props.theme.media.mdAndUp;
}, "{margin-bottom:36px;}}", function (props) {
  return props.theme.media.mdAndUp;
}, "{padding:36px;border-radius:0px 12px 12px 0px;}" + ( true ? "" : 0));
var StyledContactRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "es9w14z2"
} : 0)( true ? {
  name: "1wbmshq",
  styles: "display:flex;flex-direction:row;align-items:flex-start;margin-bottom:48px"
} : 0);
var StyledContactIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "es9w14z1"
} : 0)("align-self:flex-start;display:flex;border-radius:8px;background:rgba(255, 255, 255, 0.08);padding:16px;.", svgIconClasses/* default.root */.Z.root, "{color:#fff;width:16px;height:16px;}" + ( true ? "" : 0));
var StyledRequestCallFormContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "es9w14z0"
} : 0)("background-color:#fff;padding:24px 16px;color:", function (props) {
  return props.theme.colorsUnifications.gunmetal[100];
}, ";", function (props) {
  return props.theme.media.mdAndUp;
}, "{border-radius:12px 0px 0px 12px;padding:36px;}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(36822);
// EXTERNAL MODULE: ./public/static/icons/handset.svg
var handset = __webpack_require__(44701);
;// CONCATENATED MODULE: ./public/static/icons/email.svg
var email_path, _path2;

function email_extends() { email_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return email_extends.apply(this, arguments); }



var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/react.createElement("svg", email_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), email_path || (email_path = /*#__PURE__*/react.createElement("path", {
    d: "M16 18.718 1.445 5.938h29.117L16 18.718zM10.2 15.954 0 24.907V6.994l10.2 8.96z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M11.527 17.115 16 21.047l4.473-3.932 10.088 8.861H1.431l10.095-8.861zM21.8 15.954 32 6.994v17.92l-10.2-8.96z"
  })));
};

/* harmony default export */ var email = (SvgEmail);
// EXTERNAL MODULE: ./public/static/icons/user.svg
var user = __webpack_require__(17081);
;// CONCATENATED MODULE: ./public/static/icons/arrowLeftAlternative.svg
var arrowLeftAlternative_path;

function arrowLeftAlternative_extends() { arrowLeftAlternative_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrowLeftAlternative_extends.apply(this, arguments); }



var SvgArrowLeftAlternative = function SvgArrowLeftAlternative(props) {
  return /*#__PURE__*/react.createElement("svg", arrowLeftAlternative_extends({
    viewBox: "0 0 22 21",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), arrowLeftAlternative_path || (arrowLeftAlternative_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.731 9.188h.038H6.307l5.791-5.572c.228-.216.36-.522.36-.846 0-.324-.132-.612-.36-.846l-.738-.702a1.295 1.295 0 0 0-.89-.342c-.341 0-.644.126-.89.342L.36 10.034c-.227.216-.36.522-.36.846 0 .324.133.612.36.846l9.22 8.812c.227.216.549.342.89.342.34 0 .644-.126.89-.342l.739-.702c.227-.216.36-.522.36-.846 0-.324-.133-.594-.36-.828l-5.849-5.59h14.481c.682 0 1.269-.558 1.269-1.224V10.34c0-.63-.587-1.152-1.269-1.152Z"
  })));
};

/* harmony default export */ var arrowLeftAlternative = (SvgArrowLeftAlternative);
;// CONCATENATED MODULE: ./src/components/sections/ship-contact-form/direct-contact-info.tsx














var ContactDirectlyLink = function ContactDirectlyLink(_ref) {
  var title = _ref.title,
      linkTitle = _ref.linkTitle,
      link = _ref.link;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
    sx: {
      marginLeft: '16px',
      lineHeight: '24px'
    },
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
      variant: "body1",
      sx: {
        fontSize: '16px',
        fontWeight: '700',
        mb: '4px'
      },
      children: title
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* default */.Z, {
      component: 'a',
      href: link,
      sx: {
        fontSize: '16px',
        color: '#fff',
        fontWeight: '600',
        display: 'flex',
        alignItems: 'center',
        '&:hover, &:focus': {
          color: '#fff'
        }
      },
      children: [linkTitle, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
        inheritViewBox: true,
        component: arrowLeftAlternative,
        sx: {
          width: '12px',
          color: '#fff',
          transform: 'rotate(180deg)',
          marginLeft: '4px'
        }
      })]
    })]
  });
};

var ContactDirectlyBlock = function ContactDirectlyBlock() {
  var _React$useContext = react.useContext(locale_config/* LocaleConfigContext */.nO),
      phoneNumber = _React$useContext.phoneNumber,
      slugs = _React$useContext.slugs,
      url = _React$useContext.url;

  var expertUrl = "https://www.".concat(url, "/").concat(slugs.contact);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContactDirectly, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContactFormHeader, {
      children: (0,translation_service.__)('shipContactForm.contactUs')
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContactRow, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContactIcon, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
          inheritViewBox: true,
          component: handset/* default */.Z
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactDirectlyLink, {
        title: (0,translation_service.__)('shipContactForm.callToUs'),
        linkTitle: phoneNumber,
        link: "tel:".concat(phoneNumber)
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContactRow, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContactIcon, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
          inheritViewBox: true,
          component: email
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactDirectlyLink, {
        title: (0,translation_service.__)('shipContactForm.writeAnEmail'),
        linkTitle: (0,translation_service.__)('infoEmail'),
        link: "mailto:".concat((0,translation_service.__)('infoEmail'))
      })]
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledContactRow, {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContactIcon, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
          inheritViewBox: true,
          component: user/* default */.Z
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactDirectlyLink, {
        title: (0,translation_service.__)('shipContactForm.getInTouch'),
        linkTitle: (0,translation_service.__)('shipContactForm.selectExpert'),
        link: expertUrl
      })]
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/@mui/material/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(66489);
;// CONCATENATED MODULE: ./src/components/sections/ship-contact-form/ship-contact-form.tsx



















var ShipContactForm = function ShipContactForm(_ref) {
  var cruiseTitle = _ref.cruiseTitle,
      countryCode = _ref.countryCode,
      errors = _ref.errors,
      onSubmit = _ref.onSubmit,
      onFieldChange = _ref.onFieldChange,
      formSubmitState = _ref.formSubmitState,
      isLoading = _ref.isLoading;
  var hasValidationError = errors.firstName || errors.lastName || errors.phoneNumber;
  var hasSubmitError = formSubmitState === 'error';
  var showValidationError = hasValidationError && !hasSubmitError;
  var isRequestSent = formSubmitState === 'success';
  var showSendButton = !isLoading && !isRequestSent;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.Z, {
    disableGutters: true,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
      container: true,
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        md: 7,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledRequestCallFormContainer, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContactFormHeader, {
            children: (0,translation_service.__)('shipContactForm.header').replace('%ship%', cruiseTitle)
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* default */.Z, {
            variant: "subtitle1",
            sx: {
              fontSize: '16px',
              fontWeight: '600',
              mb: '36px'
            },
            children: (0,translation_service.__)('shipContactForm.subTitle')
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Grid/* default */.ZP, {
            container: true,
            spacing: 2,
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              md: 6,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(form_control/* FormControl */.N, {
                fullWidth: true,
                error: Boolean(errors.firstName),
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input_label/* InputLabel */.A, {
                  children: (0,translation_service.__)('general.firstName')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input/* Input */.I, {
                  name: "firstName",
                  onBlur: function onBlur(e) {
                    return onFieldChange('firstName', e.target.value);
                  }
                }), errors.firstName && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormHelperText/* default */.Z, {
                  children: (0,translation_service.__)(errors.firstName)
                })]
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              md: 6,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(form_control/* FormControl */.N, {
                fullWidth: true,
                error: Boolean(errors.lastName),
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input_label/* InputLabel */.A, {
                  children: (0,translation_service.__)('general.lastName')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input/* Input */.I, {
                  name: "lastName",
                  onBlur: function onBlur(e) {
                    return onFieldChange('lastName', e.target.value);
                  }
                }), errors.lastName && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormHelperText/* default */.Z, {
                  children: (0,translation_service.__)(errors.lastName)
                })]
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              md: 6,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(form_control/* FormControl */.N, {
                fullWidth: true,
                error: Boolean(errors.emailAddress),
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input_label/* InputLabel */.A, {
                  children: (0,translation_service.__)('general.email')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input/* Input */.I, {
                  name: "emailAddress",
                  onBlur: function onBlur(e) {
                    return onFieldChange('emailAddress', e.target.value);
                  }
                }), errors.emailAddress && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormHelperText/* default */.Z, {
                  children: (0,translation_service.__)(errors.emailAddress)
                })]
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              md: 6,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(form_control/* FormControl */.N, {
                fullWidth: true,
                error: Boolean(errors.phoneNumber),
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input_label/* InputLabel */.A, {
                  children: (0,translation_service.__)('general.phoneNumber')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(phone_input/* PhoneInput */.s, {
                  countryCode: countryCode,
                  name: "phoneNumber",
                  onChange: function onChange(fullNumber, phoneData) {
                    onFieldChange('phoneCode', phoneData.code);
                    onFieldChange('phoneNumber', phoneData.number);
                  }
                }), errors.phoneNumber && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FormHelperText/* default */.Z, {
                  children: (0,translation_service.__)(errors.phoneNumber)
                })]
              })
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
              item: true,
              xs: 12,
              children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(form_control/* FormControl */.N, {
                sx: {
                  mb: '36px'
                },
                fullWidth: true,
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input_label/* InputLabel */.A, {
                  children: (0,translation_service.__)('general.message')
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input/* Input */.I, {
                  multiline: true,
                  name: "message",
                  onBlur: function onBlur(e) {
                    return onFieldChange('message', e.target.value);
                  }
                })]
              })
            })]
          }), (hasValidationError || hasSubmitError) && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FormHelperText/* default */.Z, {
            sx: {
              marginTop: 0,
              marginBottom: '36px',
              fontSize: '14px',
              color: global_style/* colorsUnifications.watermelon.100 */.Vg.watermelon[100]
            },
            children: [hasSubmitError && (0,translation_service.__)('general.somethingWentWrong'), showValidationError && (0,translation_service.__)('general.pleaseFillAllRequiredFields')]
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(button_button/* Button */.z, {
            fullWidth: true,
            size: "large",
            variant: isRequestSent ? 'outlined' : 'contained',
            onClick: isRequestSent || isLoading ? undefined : onSubmit,
            children: [isLoading && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CircularProgress/* default */.Z, {
              size: 24,
              color: "inherit",
              sx: {
                mr: '8px'
              }
            }), isRequestSent && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
              inheritViewBox: true,
              component: checkmark_plain/* default */.Z,
              sx: {
                width: '12px',
                height: '12px',
                mr: '8px'
              }
            }), isRequestSent && (0,translation_service.__)('general.thanksForYourRequest'), showSendButton && (0,translation_service.__)('send')]
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        md: 5,
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContactDirectlyBlock, {})
      })]
    })
  });
};
// EXTERNAL MODULE: ./src/api/resources.ts
var resources = __webpack_require__(15206);
// EXTERNAL MODULE: ./src/contexts/booking/constants.ts
var constants = __webpack_require__(5529);
// EXTERNAL MODULE: ./src/contexts/booking/helpers.ts
var helpers = __webpack_require__(8971);
;// CONCATENATED MODULE: ./src/modules/ship-contact-mod.tsx





function ship_contact_mod_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ship_contact_mod_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ship_contact_mod_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ship_contact_mod_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var createUniqueId = function createUniqueId() {
  return Math.random().toString(36).substr(2, 16);
};
var errorMessageMap = {
  firstName: 'error.firstName',
  lastName: 'error.lastName',
  emailAddress: 'error.emailError',
  phoneNumber: 'error.phoneNumber'
};
var FormSchema = es/* object */.Ry().shape({
  firstName: es/* string */.Z_().required('error.firstName').default(''),
  lastName: es/* string */.Z_().required('error.lastName').default(''),
  emailAddress: es/* string */.Z_().required('error.emailError').email('error.emailError').default(''),
  phoneCode: es/* string */.Z_().required().default(''),
  phoneNumber: es/* string */.Z_().required('error.phoneNumber').min(5, 'error.phoneNumber').max(15, 'error.phoneNumber').default(''),
  message: es/* string */.Z_().default('')
});
var ShipContactMod = function ShipContactMod(_ref) {
  var getLandingPage = _ref.getLandingPage;

  var _React$useContext = react.useContext(locale_config/* LocaleConfigContext */.nO),
      code = _React$useContext.code,
      url = _React$useContext.url;

  var _React$useState = react.useState('indefinite'),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      formSubmitState = _React$useState2[0],
      setFormSubmitState = _React$useState2[1];

  var _React$useState3 = react.useState(false),
      _React$useState4 = (0,slicedToArray/* default */.Z)(_React$useState3, 2),
      isLoading = _React$useState4[0],
      setIsLoading = _React$useState4[1];

  var getRequestData = function getRequestData(userData) {
    return {
      channel: 'NoOnlineRuleApplies',
      firstName: userData.firstName,
      lastName: userData.lastName,
      phoneNumber: "".concat(userData['phoneCode']).concat(userData['phoneNumber']),
      emailAddress: userData.emailAddress,
      domain: url,
      userId: null,
      sessionId: null,
      message: userData.message,
      bookingCode: createUniqueId(),
      contactMethod: 'ContactForm',
      bookingUrl: window.location.href
    };
  };

  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: FormSchema.getDefault(),
    validationSchema: FormSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: function () {
      var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(values, _ref2) {
        var setErrors, requestData, response, errors, formikErrors;
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setErrors = _ref2.setErrors;
                setFormSubmitState('indefinite');
                setIsLoading(true);
                requestData = getRequestData(values);
                _context.prev = 4;
                _context.next = 7;
                return (0,resources/* submitShipContactForm */.Oi)(requestData);

              case 7:
                response = _context.sent;

                if (response !== null && response !== void 0 && response.isSuccessful) {
                  setFormSubmitState('success');
                }

                _context.next = 20;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](4);
                errors = (0,helpers/* getApiValidationErrors */.OF)(_context.t0);

                if (errors.length) {
                  _context.next = 17;
                  break;
                }

                setFormSubmitState('error');
                return _context.abrupt("return");

              case 17:
                formikErrors = errors.reduce(function (acc, currentValue) {
                  var key = currentValue.field;

                  if (!values[key] || !(key in errorMessageMap)) {
                    return acc;
                  }

                  return ship_contact_mod_objectSpread(ship_contact_mod_objectSpread({}, acc), {}, (0,defineProperty/* default */.Z)({}, key, errorMessageMap[key]));
                }, {});
                setErrors(formikErrors);
                setFormSubmitState('error');

              case 20:
                _context.prev = 20;
                setIsLoading(false);
                return _context.finish(20);

              case 23:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 11, 20, 23]]);
      }));

      function onSubmit(_x, _x2) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });

  var handleSubmit = function handleSubmit() {
    formik.submitForm();
  };

  var handleFieldChange = function handleFieldChange(name, val) {
    var validate = Boolean(formik.errors[name]);
    formik.setFieldValue(name, val, validate);
  };

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShipContactForm, {
    isLoading: isLoading,
    formSubmitState: formSubmitState,
    cruiseTitle: getLandingPage.title,
    countryCode: code ? code.toUpperCase() : constants/* DE_COUNTRY_CODE */.FV,
    errors: formik.errors,
    onFieldChange: handleFieldChange,
    onSubmit: handleSubmit
  });
};
;// CONCATENATED MODULE: ./src/components/sections/ship-detail/ship-column/ship-column.style.tsx


var StyledTable = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("table",  true ? {
  target: "e1418roq1"
} : 0)("width:375px;height:100%;display:inline-table;position:relative;border-collapse:collapse;@media (max-width: 480px){width:100%;}colgroup{col:first-child{width:60%;background-color:rgba(0, 53, 93, 0.7);}col:last-child{width:40%;background-color:rgba(0, 53, 93, 0.9);@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{background-color:rgba(0, 53, 93, 0.8);}}}thead th{font-weight:600;font-size:", function (props) {
  return props.theme.fontSize.headlineS;
}, ";padding:", function (props) {
  return "".concat(props.theme.spacing.extraLarge, " ").concat(props.theme.spacing.medium, " ").concat(props.theme.spacing.extraLarge, " ").concat(props.theme.spacing.extraLarge);
}, ";@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.headlineM;
}, ";}@media ", global_style/* mediaQueries.allDesktop */.w5.allDesktop, "{padding:", function (props) {
  return "".concat(props.theme.spacing.xxxLarge, " ").concat(props.theme.spacing.medium, " ").concat(props.theme.spacing.extraLarge, " ").concat(props.theme.spacing.xxxLarge);
}, ";}}tbody th{padding:", function (props) {
  return "".concat(props.theme.spacing.small, " ").concat(props.theme.spacing.medium, " ").concat(props.theme.spacing.small, " ").concat(props.theme.spacing.extraLarge);
}, ";font-weight:500;@media ", global_style/* mediaQueries.allDesktop */.w5.allDesktop, "{padding:", function (props) {
  return "".concat(props.theme.spacing.small, " ").concat(props.theme.spacing.medium, " ").concat(props.theme.spacing.small, " ").concat(props.theme.spacing.xxxLarge);
}, ";}}tr th,tr td{text-align:left;}tr:not(:last-child){th,td{position:relative;}th::after,td::after{content:'';border-bottom:1px solid rgba(216, 216, 216, 0.08);position:absolute;bottom:0;width:calc(100% - ", function (props) {
  return props.theme.spacing.extraLarge;
}, ");@media ", global_style/* mediaQueries.allDesktop */.w5.allDesktop, "{width:calc(100% - ", function (props) {
  return props.theme.spacing.xxxLarge;
}, ");}}th::after{left:", function (props) {
  return props.theme.spacing.extraLarge;
}, ";@media ", global_style/* mediaQueries.allDesktop */.w5.allDesktop, "{left:", function (props) {
  return props.theme.spacing.xxxLarge;
}, ";}}td::after{left:0;}}font-size:", function (props) {
  return props.theme.fontSize.copyTextXL;
}, ";tbody{tr:last-child{td,th{padding-bottom:", function (props) {
  return props.theme.spacing.extraLarge;
}, ";@media ", global_style/* mediaQueries.allDesktop */.w5.allDesktop, "{padding-bottom:", function (props) {
  return props.theme.spacing.xxxLarge;
}, ";}}}td{color:", function (props) {
  return props.theme.shades.lightGrey;
}, ";padding:", function (props) {
  return "".concat(props.theme.spacing.small, " ").concat(props.theme.spacing.extraLarge, " ").concat(props.theme.spacing.small, " ").concat(props.theme.spacing.extraLarge);
}, ";@media ", global_style/* mediaQueries.allDesktop */.w5.allDesktop, "{padding:", function (props) {
  return "".concat(props.theme.spacing.small, " ").concat(props.theme.spacing.xxxLarge, " ").concat(props.theme.spacing.small, " ").concat(props.theme.spacing.extraLarge);
}, ";}}}" + ( true ? "" : 0));
var StyledShipColumnWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1418roq0"
} : 0)("max-width:1170px;height:100%;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{margin-left:40px;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{margin:0 auto;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/components/sections/ship-detail/ship-detail-label.ts
var shipDetailItemsLabels = {
  launchDate: {
    label: 'shipLaunchDate'
  },
  refurbishmentYear: {
    label: 'shipRefurbishmentYear'
  },
  company: {
    label: 'shipCompany'
  },
  length: {
    label: 'shipLength'
  },
  draft: {
    label: 'shipDraft'
  },
  speed: {
    label: 'shipSpeed'
  },
  decks: {
    label: 'shipDecks'
  },
  passengers: {
    label: 'shipPassengers'
  },
  crew: {
    label: 'shipCrew'
  },
  boardLanguage: {
    label: 'shipBoardLanguage'
  },
  boardCurrency: {
    label: 'shipBoardCurrency'
  }
};
;// CONCATENATED MODULE: ./src/components/sections/ship-detail/ship-column/ship-column.tsx







var ShipColumn = function ShipColumn(_ref) {
  var shipItems = _ref.shipItems,
      headline = _ref.headline;
  var shipList = shipItems && Object.keys(shipItems).map(function (key) {
    var value = shipItems[key].value;

    if (!value) {
      return;
    }

    return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
        children: (0,translation_service.__)(shipItems[key].label)
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
        children: formattedAmount(shipItems[key])
      })]
    }, key);
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledShipColumnWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledTable, {
      "aria-label": "ship data",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("colgroup", {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("col", {}), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("col", {})]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("tr", {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
            children: headline
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {})]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
        children: shipList
      })]
    })
  });
};

var formattedAmount = function formattedAmount(item) {
  return typeof item.value === 'number' && item.label !== shipDetailItemsLabels.launchDate.label && item.label !== shipDetailItemsLabels.refurbishmentYear.label ? (0,formatting/* numberFormat */.Y4)(item.value) : item.value;
};
;// CONCATENATED MODULE: ./src/components/sections/ship-detail/ship-detail.style.tsx


var StyledShipDetailBg = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "ei33ea60"
} : 0)("position:relative;h2{font-size:", function (props) {
  return props.theme.fontSize.headlineS;
}, ";font-weight:600;margin-bottom:10px;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.headlineM;
}, ";}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/components/sections/ship-detail/ship-detail.tsx








var ShipDetail = function ShipDetail(props) {
  var _shipItems$background, _shipItems$background2, _shipItems$background3, _shipItems$background4;

  var shipItems = props.shipItems;
  if (!shipItems) return null;
  var url = ((_shipItems$background = shipItems.backgroundImage) === null || _shipItems$background === void 0 ? void 0 : (_shipItems$background2 = _shipItems$background.image) === null || _shipItems$background2 === void 0 ? void 0 : _shipItems$background2.url) || shipItems.bannerImage || '';
  var thumb = ((_shipItems$background3 = shipItems.backgroundImage) === null || _shipItems$background3 === void 0 ? void 0 : (_shipItems$background4 = _shipItems$background3.thumb) === null || _shipItems$background4 === void 0 ? void 0 : _shipItems$background4.url) || '';
  if (!url) return null;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledShipDetailBg, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(image_image/* NextImage */.o, {
      fill: true,
      isBackground: true,
      placeholder: thumb,
      imgUrl: url,
      style: {
        objectFit: 'cover'
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShipColumn, {
        shipItems: normalizeShipTableData(shipItems),
        headline: translation_service/* TranslationService.translate */.D.translate('shipDetail')
      })
    })
  });
};

var normalizeShipTableData = function normalizeShipTableData(items) {
  var shipDetailItems = shipDetailItemsLabels;
  Object.entries(items).forEach(function (_ref) {
    var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
        key = _ref2[0],
        entry = _ref2[1];

    if (!(key in shipDetailItems) || !entry) return;

    if (key === 'speed') {
      shipDetailItems[key].value = "".concat(entry, " ").concat((0,translation_service.__)('knots'));
    } else if (key === 'length' || key === 'draft') {
      shipDetailItems[key].value = "".concat(entry, " ").concat((0,translation_service.__)('metre'));
    } else {
      shipDetailItems[key].value = entry;
    }
  });
  return shipDetailItems;
};

/* harmony default export */ var ship_detail = (ShipDetail);
;// CONCATENATED MODULE: ./src/modules/ship-details-mod.tsx



var ShipDetailsMod = function ShipDetailsMod(_ref) {
  var _shipDetailsData$head;

  var getLandingPage = _ref.getLandingPage,
      modulesData = _ref.modulesData;
  var shipDetailsData = modulesData["ship".concat(getLandingPage.id)];

  if (!shipDetailsData || !shipDetailsData.factsAndFigures) {
    return null;
  }

  var factsAndFigures = shipDetailsData.factsAndFigures;
  var boardLanguage = factsAndFigures.spokenLanguages && factsAndFigures.spokenLanguages.length ? factsAndFigures.spokenLanguages[0] : '';
  var boardCurrency = factsAndFigures.currency && factsAndFigures.currency.length ? factsAndFigures.currency[0] : '';
  var shipItems = {
    launchDate: factsAndFigures.manufactureYear,
    refurbishmentYear: factsAndFigures.refurbishmentYear || null,
    // @TODO check the actual format that's being passed
    company: shipDetailsData.company.title,
    length: factsAndFigures.length,
    draft: factsAndFigures.draft,
    speed: factsAndFigures.speed,
    decks: factsAndFigures.decks,
    passengers: factsAndFigures.passengerCapacity,
    crew: factsAndFigures.crewMembers,
    boardLanguage: boardLanguage,
    boardCurrency: boardCurrency,
    backgroundImage: shipDetailsData === null || shipDetailsData === void 0 ? void 0 : (_shipDetailsData$head = shipDetailsData.headerImages) === null || _shipDetailsData$head === void 0 ? void 0 : _shipDetailsData$head[1],
    bannerImage: shipDetailsData === null || shipDetailsData === void 0 ? void 0 : shipDetailsData.bannerImage
  };
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ship_detail, {
    shipItems: shipItems
  }, "shipDetails");
};
// EXTERNAL MODULE: ./src/contexts/device/device.tsx
var device_device = __webpack_require__(90780);
// EXTERNAL MODULE: ./public/static/icons/Pin.svg
var Pin = __webpack_require__(370);
// EXTERNAL MODULE: ./public/static/icons/directionArrow.svg
var directionArrow = __webpack_require__(86022);
;// CONCATENATED MODULE: ./src/components/sections/ship-position/ship-position.style.tsx



var ship_position_style_excluded = ["margin", "transform"],
    _excluded2 = ["margin"];

function ship_position_style_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ship_position_style_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ship_position_style_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ship_position_style_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var assetPrefix = (0,buildVersion/* getAssetsPrefix */.x)();
var StyledBgWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e189l97z8"
} : 0)("height:245px;max-width:1920px;margin:0 auto;position:relative;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{height:195px;}&>div{background-image:url('", assetPrefix, "/static/images/ship-position-bg-mobile.jpg');background-size:cover;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{background-image:url('", assetPrefix, "/static/images/ship-position-bg-tablet.jpg');}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{background-image:url('", assetPrefix, "/static/images/ship-position-bg-desktop.jpg');}}" + ( true ? "" : 0));
var ship_position_style_StyledContent = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e189l97z7"
} : 0)("display:flex;align-items:center;flex-direction:column;justify-content:center;text-align:center;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{justify-content:space-around;flex-direction:row;padding:18px;text-align:left;}" + ( true ? "" : 0));
var StyledShipPositionInfo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e189l97z6"
} : 0)("margin-bottom:8px;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{margin-right:70px;}" + ( true ? "" : 0));
var StyledShipLocation = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e189l97z5"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";font-weight:600;margin-bottom:8px;" + ( true ? "" : 0));
var PinLogo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(function (_ref) {
  var margin = _ref.margin,
      transform = _ref.transform,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, ship_position_style_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pin/* default */.Z, ship_position_style_objectSpread({}, rest));
},  true ? {
  target: "e189l97z4"
} : 0)("margin:", function (props) {
  return props.margin;
}, ";transform:", function (props) {
  return props.transform;
}, ";" + ( true ? "" : 0));
var DirectionArrow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(function (_ref2) {
  var margin = _ref2.margin,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(directionArrow/* default */.Z, ship_position_style_objectSpread({}, rest));
},  true ? {
  target: "e189l97z3"
} : 0)("margin:", function (props) {
  return props.margin;
}, ";" + ( true ? "" : 0));
var StyledLatLong = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e189l97z2"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextL;
}, ";margin-bottom:8px;line-height:1.3;" + ( true ? "" : 0));
var ship_position_style_StyledButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e189l97z1"
} : 0)("@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{margin:0;}" + ( true ? "" : 0));
var StyledTitleWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e189l97z0"
} : 0)(section_headline_style/* StyledHeader */.e, "{padding-bottom:0px;background-color:transparent!important;@media ", global_style/* mediaQueries.phone */.w5.phone, "{padding:5px 0 15px;}}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/components/sections/ship-position/ship-position.tsx













var ShipPosition = function ShipPosition(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude,
      name = _ref.name,
      nextPort = _ref.nextPort,
      lastPort = _ref.lastPort,
      href = _ref.href;
  var lastPortName = lastPort === null || lastPort === void 0 ? void 0 : lastPort.name;
  var nextPortName = nextPort === null || nextPort === void 0 ? void 0 : nextPort.name;
  var nextPortCountryInitials = nextPort === null || nextPort === void 0 ? void 0 : nextPort.countryInitials;
  var device = react.useContext(device_device/* DeviceContext */.Tp);

  if (!name && !lastPortName && !latitude && !longitude && !nextPortName) {
    return null;
  }

  var assetPrefix = (0,buildVersion/* getAssetsPrefix */.x)();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBgWrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(image_image/* NextImage */.o, {
      placeholder: "".concat(assetPrefix, "/static/images/ship-position-bg-low-quality.jpg"),
      imgUrl: "".concat(assetPrefix, "/static/images/ship-position-bg-").concat(device, ".jpg"),
      isBackground: true,
      fill: true,
      customContentStyle: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column'
      },
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTitleWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(section_headline/* SectionHeadline */.A, {
          firstChunk: name,
          secondChunk: (0,translation_service.__)('actualPosition'),
          color: "light"
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ship_position_style_StyledContent, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledShipPositionInfo, {
          children: [!!lastPortName && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledShipLocation, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PinLogo, {
              width: 14,
              height: 20,
              fill: global_style/* theme.shades.white */.rS.shades.white,
              margin: "0 5px 0 0",
              transform: "translateY(2px)"
            }), lastPortName, nextPortName && nextPortCountryInitials && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DirectionArrow, {
                width: 16,
                height: 10,
                fill: global_style/* theme.shades.white */.rS.shades.white,
                margin: "0 6px"
              }), nextPortName, ", ", nextPortCountryInitials]
            })]
          }), latitude && longitude && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledLatLong, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              children: [(0,translation_service.__)('latitudeLabel'), ": ", latitude, "\xB0"]
            }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
              children: [(0,translation_service.__)('longitudeLabel'), ": ", longitude, "\xB0"]
            })]
          })]
        }), !!href && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ship_position_style_StyledButtonWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
            style: {
              height: '40px',
              width: '226px',
              color: global_style/* theme.shades.white */.rS.shades.white,
              borderColor: global_style/* theme.shades.white */.rS.shades.white,
              fontSize: global_style/* theme.fontSize.copyTextL */.rS.fontSize.copyTextL
            },
            tertiary: true,
            redirectUrl: href,
            onClick: function onClick() {
              EventTracker/* eventTracker.track */.xT.track({
                event: 'click',
                category: 'link-to-subpage',
                action: 'ship-position-module',
                label: "ship-".concat(name)
              });
            },
            children: (0,translation_service.__)('shipPositionBtnLabel')
          })
        })]
      })]
    })
  });
};
;// CONCATENATED MODULE: ./src/modules/ship-live-position-mod.tsx




var ShipLivePositionMod = function ShipLivePositionMod(_ref) {
  var getLandingPage = _ref.getLandingPage,
      modulesData = _ref.modulesData;
  var localeConfig = react.useContext(locale_config/* LocaleConfigContext */.nO);
  var data = modulesData["ship".concat(getLandingPage.id)];

  if (!data || !data.livePosition) {
    return null;
  }

  var _data$livePosition = data.livePosition,
      lastPort = _data$livePosition.lastPort,
      latitude = _data$livePosition.latitude,
      longitude = _data$livePosition.longitude,
      speed = _data$livePosition.speed,
      course = _data$livePosition.course,
      nextPort = _data$livePosition.nextPort;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShipPosition, {
    latitude: latitude,
    longitude: longitude,
    name: getLandingPage.title || '',
    speed: "".concat(speed),
    course: course,
    nextPort: nextPort,
    lastPort: lastPort,
    href: "/".concat(getLandingPage.url, "/").concat(localeConfig.slugs.liveposition).replace('//', '/')
  }, "shipLivePosition");
};
;// CONCATENATED MODULE: ./src/components/sections/ship-sections/ship-sections.tsx



function ship_sections_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ship_sections_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ship_sections_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ship_sections_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }



















var SectionWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1r9m4nx1"
} : 0)("width:100%;margin-bottom:", function (_ref) {
  var theme = _ref.theme;
  return theme.spacing.landingComponent.small;
}, ";@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{margin-bottom:", function (_ref2) {
  var theme = _ref2.theme;
  return theme.spacing.landingComponent.medium;
}, ";}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{margin-bottom:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.spacing.landingComponent.large;
}, ";}" + ( true ? "" : 0));

var HighlightsSectionWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1r9m4nx0"
} : 0)("background-color:", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorsUnifications.white[100];
}, ";@media ", global_style/* mediaQueries.phone */.w5.phone, "{padding-top:30px;}@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{margin-top:-42px;}" + ( true ? "" : 0));

var ShipPageSections = function ShipPageSections(_ref5) {
  var pageProps = _ref5.pageProps,
      refs = _ref5.refs;
  var localeConfig = react.useContext(locale_config/* LocaleConfigContext */.nO);
  var ugcProps = (0,ugc_data/* getUGCPropsFromData */.Hz)(ship_sections_objectSpread(ship_sections_objectSpread({}, pageProps), {}, {
    ugcSlug: localeConfig.slugs.ugc
  }));
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightsSectionWrapper, {
      ref: refs[shipLanding/* sectionNames.highlights */.A0.highlights],
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HighlightsMod, ship_sections_objectSpread({}, pageProps))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionWrapper, {
      ref: refs[shipLanding/* sectionNames.offerTeaser */.A0.offerTeaser],
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(offer_teaser_mod/* OfferTeaserMod */.f, ship_sections_objectSpread({}, pageProps))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionWrapper, {
      ref: refs[shipLanding/* sectionNames.overview */.A0.overview],
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverviewMod, ship_sections_objectSpread({}, pageProps))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionWrapper, {
      ref: refs[shipLanding/* sectionNames.shipLivePosition */.A0.shipLivePosition],
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShipLivePositionMod, ship_sections_objectSpread({}, pageProps))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShipDetailsMod, ship_sections_objectSpread({}, pageProps))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionWrapper, {
      ref: refs[shipLanding/* sectionNames.cabin */.A0.cabin],
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CabinMod, ship_sections_objectSpread({}, pageProps))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionWrapper, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShipContactMod, ship_sections_objectSpread({}, pageProps))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionWrapper, {
      ref: refs[shipLanding/* sectionNames.reviews */.A0.reviews],
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ugc/* UGC */.s, ship_sections_objectSpread({}, ugcProps))
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SectionWrapper, {
      ref: refs[shipLanding/* sectionNames.shipAmenities */.A0.shipAmenities],
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ShipAmenitiesMod, ship_sections_objectSpread({}, pageProps))
    })]
  });
};

/* harmony default export */ var ship_sections = (/*#__PURE__*/react.memo(ShipPageSections));
// EXTERNAL MODULE: ./src/utils/object-keys.ts
var object_keys = __webpack_require__(43711);
;// CONCATENATED MODULE: ./src/hooks/use-element-on-screen/use-element-on-screen.ts




/**
 * Method is detecting which element is currently on screen
 *
 * @function useElementOnScreen
 * @param `Object<IRefs>`
 *
 * `refs` is the object of refs with corresponding names as keys
 * `offset` is by default 0, but you can overwrite in case you have some fixed elements or similar
 */
function useElementOnScreen(_ref) {
  var refs = _ref.refs,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 0 : _ref$offset;

  var _React$useState = react.useState(''),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      currentElementName = _React$useState2[0],
      setCurrentElementName = _React$useState2[1];

  react.useEffect(function () {
    var refKeys = (0,object_keys/* objectKeys */.Y)(refs);

    function listener() {
      refKeys.forEach(function (refName) {
        var ref = refs[refName];
        if (!ref.current) return;

        var _ref$current$getBound = ref.current.getBoundingClientRect(),
            top = _ref$current$getBound.top,
            bottom = _ref$current$getBound.bottom;

        if (top <= offset && bottom > offset) {
          setCurrentElementName(refName);
        }
      });
    }

    window.document.addEventListener('scroll', listener);
    return function () {
      window.document.removeEventListener('scroll', listener);
    };
  }, [refs, offset, currentElementName]);
  return {
    currentElementName: currentElementName
  };
}
// EXTERNAL MODULE: ./src/hooks/useHandleSearchSubmit.tsx
var useHandleSearchSubmit = __webpack_require__(3354);
// EXTERNAL MODULE: ./src/components/atoms/label-box/label-box.tsx + 6 modules
var label_box = __webpack_require__(61128);
// EXTERNAL MODULE: ./src/components/atoms/rating/rating.tsx + 3 modules
var rating = __webpack_require__(58761);
// EXTERNAL MODULE: ./src/components/hoc/sticky/sticky.tsx + 2 modules
var sticky = __webpack_require__(18210);
;// CONCATENATED MODULE: ./src/components/molecules/information-board-card/information-board-card.style.tsx


function information_board_card_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var StyledInfoBoardCardContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("article",  true ? {
  target: "ej9e59s17"
} : 0)("color:", function (props) {
  return props.theme.shades.darkGrey;
}, ";width:100%;padding-left:8px;padding-right:8px;display:flex;margin-bottom:20px;@media ", global_style/* mediaQueries.tablet */.w5.tablet, "{width:calc(1 / 2 * 100%);}@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{width:calc(1 / 3 * 100%);}" + ( true ? "" : 0));
var information_board_card_style_StyledText = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("p",  true ? {
  target: "ej9e59s16"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextM;
}, ";text-align:left;line-height:1.6;" + ( true ? "" : 0))));
var StyledTopSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ej9e59s15"
} : 0)( true ? {
  name: "gjfyjj",
  styles: "img{object-fit:cover;object-position:center center;height:100%;width:100%;user-select:none;}"
} : 0);
var information_board_card_style_StyledImageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ej9e59s14"
} : 0)( true ? {
  name: "1cwloic",
  styles: "width:100%;overflow:hidden"
} : 0);
var StyledOnDemandPrice = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("div",  true ? {
  target: "ej9e59s13"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.headlineM;
}, ";font-weight:600;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";line-height:46px;" + ( true ? "" : 0))));
var information_board_card_style_StyledAspectRatio = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ej9e59s12"
} : 0)("position:relative;&::before{position:relative;display:block;content:'';padding-bottom:calc(225 / 350 * 100%);@media ", global_style/* mediaQueries.smallDesktopAndUp */.w5.smallDesktopAndUp, "{padding-bottom:calc(225 / 370 * 100%);}}" + ( true ? "" : 0));
var information_board_card_style_StyledContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ej9e59s11"
} : 0)( true ? {
  name: "lol706",
  styles: "position:absolute;top:0;bottom:0;left:0;right:0;overflow:hidden"
} : 0);
var StyledMiddleSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ej9e59s10"
} : 0)( true ? {
  name: "1yp5lhm",
  styles: "width:100%;padding:15px 10px 10px 10px;display:flex;flex-direction:column"
} : 0);
var StyledBorder = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("hr",  true ? {
  target: "ej9e59s9"
} : 0)("background:transparent;margin:0 10px;border-color:transparent;border-bottom:1px solid ", function (props) {
  return props.theme.shades.lightMidGrey;
}, ";" + ( true ? "" : 0))));
var StyledCardHeadline = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "ej9e59s8"
} : 0)("display:flex;flex:auto;font-size:", function (props) {
  return props.theme.fontSize.headlineS;
}, ";font-weight:700;line-height:21px;margin:0 0 8.5px;color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";" + ( true ? "" : 0))));
var StyledInfoBox = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ej9e59s7"
} : 0)( true ? {
  name: "1eoy87d",
  styles: "display:flex;justify-content:space-between"
} : 0);
var StyledBottomSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "ej9e59s6"
} : 0)( true ? {
  name: "1pri73f",
  styles: "padding:15px 10px;flex-grow:1;display:flex;flex-direction:column;justify-content:space-between"
} : 0);
var StyledInfoCardLink = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("a",  true ? {
  target: "ej9e59s5"
} : 0)("color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";text-decoration:none;flex-grow:1;display:flex;flex-direction:column;cursor:pointer;&:focus,&:active,&:visited,&:hover{color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";text-decoration:none;}" + ( true ? "" : 0))));
var StyledIconLabelList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "ej9e59s4"
} : 0)( true ? {
  name: "14506fv",
  styles: "padding-left:0;list-style:none;width:100%;display:flex;flex-flow:row wrap;align-items:flex-start;justify-content:space-between"
} : 0);
var StyledIconLabelListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "ej9e59s3"
} : 0)( true ? {
  name: "19frp3m",
  styles: "width:50%;margin-bottom:10px"
} : 0);
var StyledTextLabelList = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("ul",  true ? {
  target: "ej9e59s2"
} : 0)("padding-left:0;list-style:none;display:flex;margin-top:5px;flex-wrap:none;overflow:hidden;max-width:100%;flex-wrap:wrap;/* @TODO this label list has to be abstracted */max-height:", function (_ref) {
  var _ref$rows = _ref.rows,
      rows = _ref$rows === void 0 ? 1 : _ref$rows;
  return 30 * rows;
}, "px;flex-direction:row;" + ( true ? "" : 0));
var StyledUserLove = /*#__PURE__*/(/* unused pure expression or super */ null && (_styled("span",  true ? {
  target: "ej9e59s1"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextS;
}, ";padding-top:", function (props) {
  return props.theme.spacing.large;
}, ";color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";display:block;" + ( true ? "" : 0))));
var StyledTextLabelListItem = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("li",  true ? {
  target: "ej9e59s0"
} : 0)( true ? {
  name: "1svqe0v",
  styles: "margin:2.5px 5px 2.5px 0;word-break:none;word-wrap:none;white-space:nowrap;& :last-child{margin-right:0;}"
} : 0);
;// CONCATENATED MODULE: ./src/components/molecules/nav-tabs/nav-tabs.style.tsx

var StyledNav = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1fufsbp0"
} : 0)(".MuiTabs-scroller{margin:0 auto;max-width:1184px;}.nav-tabs-tab{font-weight:400;font-size:", function (props) {
  return props.theme.fontSize.copyTextS;
}, ";transition:opacity 0.3s;&:hover,&:focus{color:", function (props) {
  return props.theme.shades.white;
}, ";text-decoration:unset;}&:hover{opacity:1;}span{transition:transform 0.3s;}}.nav-tabs-indicator{background-color:", function (props) {
  return props.theme.shades.white;
}, ";bottom:1px;height:3px;}.nav-bar-active{span{transform:scale(1.1);}&:hover{opacity:1;}}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./node_modules/@mui/material/ButtonBase/ButtonBase.js + 4 modules
var ButtonBase = __webpack_require__(49990);
// EXTERNAL MODULE: ./src/components/atoms/arrow/arrow.tsx + 1 modules
var arrow_arrow = __webpack_require__(5966);
;// CONCATENATED MODULE: ./src/components/molecules/nav-tabs/nav-tabs.tsx



var nav_tabs_excluded = ["classes", "className", "direction", "orientation", "visible"];

function nav_tabs_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function nav_tabs_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? nav_tabs_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : nav_tabs_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var NavTabs = function NavTabs(props) {
  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      currentTabIndex = _React$useState2[0],
      setCurrentTabIndex = _React$useState2[1];

  var device = react.useContext(device_device/* DeviceContext */.Tp);

  var handleChange = function handleChange(_event, newValue) {
    props.onSelect(newValue);
  };

  react.useEffect(function () {
    setCurrentTabIndex(props.currentTabIndex || 0);
  }, [props.currentTabIndex]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledNav, {
    "data-testid": "nav-tabs",
    active: currentTabIndex,
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tabs/* default */.Z, {
      variant: device === 'desktop' ? "standard" : "scrollable",
      value: currentTabIndex,
      onChange: handleChange,
      "aria-label": "nav tabs",
      className: "nav-tabs",
      classes: {
        indicator: "nav-tabs-indicator"
      },
      scrollButtons: true,
      ScrollButtonComponent: function ScrollButtonComponent(_ref) {
        var classes = _ref.classes,
            classNameProp = _ref.className,
            direction = _ref.direction,
            orientation = _ref.orientation,
            visible = _ref.visible,
            other = (0,objectWithoutProperties/* default */.Z)(_ref, nav_tabs_excluded);

        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonBase/* default */.Z, nav_tabs_objectSpread(nav_tabs_objectSpread({
          component: "div",
          className: classNameProp
        }, other), {}, {
          children: direction === 'left' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(arrow_arrow/* Arrow */.E, {
            size: "M",
            orientation: "left",
            style: {
              margin: '0 2px',
              opacity: visible ? 1 : 0.5,
              fill: '#fff'
            }
          }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(arrow_arrow/* Arrow */.E, {
            size: "M",
            orientation: "right",
            style: {
              margin: '0 2px',
              opacity: visible ? 1 : 0.5,
              fill: '#fff'
            }
          })
        }));
      },
      style: {
        backgroundColor: global_style/* theme.colors.main2 */.rS.colors.main2,
        color: global_style/* theme.shades.white */.rS.shades.white,
        minHeight: device === 'mobile' ? 50 : 40
      },
      children: props.tabs.map(function (tab) {
        return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Tab/* default */.Z, {
          component: "a",
          onClick: function onClick(event) {
            // @TODO remove this for navigating
            event.preventDefault();
          },
          className: "nav-tabs-tab",
          classes: {
            selected: "nav-bar-active"
          },
          label: tab.title,
          style: {
            minHeight: device === 'mobile' ? 50 : 40,
            fontSize: 14,
            color: global_style/* theme.shades.white */.rS.shades.white
          },
          disableTouchRipple: device === 'mobile'
        }, tab.key);
      })
    })
  });
};
// EXTERNAL MODULE: ./src/components/molecules/price/index.ts
var price = __webpack_require__(23554);
;// CONCATENATED MODULE: ./src/components/molecules/floating-sticky-bar/floating-sticky-bar.style.tsx


function floating_sticky_bar_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }




var StyledNavTabs = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e6u4gvz7"
} : 0)( true ? {
  name: "1v8apbr",
  styles: "position:relative;z-index:-1"
} : 0);

var _ref4 =  true ? {
  name: "1tl27ts",
  styles: "transition:0.5s all 0.3s;visibility:unset;opacity:1;transform:translate3d(0, 0, 0)"
} : 0;

var _ref5 =  true ? {
  name: "1onlmsm",
  styles: "overflow:hidden;opacity:0;height:0"
} : 0;

var StyledSticky = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e6u4gvz6"
} : 0)(function (props) {
  return props.hide && !props.sticky && _ref5;
}, " position:relative;z-index:1;&>div:nth-child(1){display:", function (_ref6) {
  var sticky = _ref6.sticky,
      stageModuleType = _ref6.stageModuleType;

  if (stageModuleType !== 'searchStage') {
    return 'none';
  }

  return !sticky ? 'none' : 'flex';
}, ";}", StyledNavTabs, "{", function (props) {
  return props.sticky ? _ref4 : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("visibility:", props.stageModuleType === 'searchStage' ? 'visible' : 'hidden', ";opacity:", props.stageModuleType === 'searchStage' ? '1' : '0', ";transform:translate3d(0, -100%, 0);" + ( true ? "" : 0),  true ? "" : 0);
}, ";}" + ( true ? "" : 0));

var _ref3 =  true ? {
  name: "1qemjat",
  styles: "flex-wrap:wrap"
} : 0;

var Row1 = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e6u4gvz5"
} : 0)("display:flex;align-items:center;", function (props) {
  return props.wrap === 'true' ? _ref3 : null;
}, ";" + ( true ? "" : 0));
var Row2 = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e6u4gvz4"
} : 0)( true ? {
  name: "1laz9o6",
  styles: "display:flex;justify-content:space-between;align-items:flex-end"
} : 0);

var floating_sticky_bar_style_ref2 =  true ? {
  name: "ve4rp7",
  styles: "box-shadow:0 0 14px 0 rgba(0, 0, 0, 0.3)"
} : 0;

var StyledCard = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e6u4gvz3"
} : 0)("max-width:calc(1920px - 20px * 2);width:calc(100% - 20px * 2);background-color:", function (props) {
  return props.theme.shades.white;
}, ";color:", function (props) {
  return props.theme.shades.blackGrey;
}, ";padding:20px;flex-direction:column;justify-content:space-between;transition:0.5s all;margin-left:auto;margin-right:auto;@media ", global_style/* mediaQueries.phone */.w5.phone, "{>", Row1, "{max-width:42%;}}@media (max-width: 360px){>", Row1, "{max-width:40%;}}", function (props) {
  return props.sticky ? /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("max-width:none;width:100%;flex-direction:row;justify-content:space-between;margin-top:0;margin-bottom:0;box-shadow:0;padding:0;height:65px;align-items:center;padding-left:10px;@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{padding-left:20px;}@media ", global_style/* mediaQueries.tablet */.w5.tablet, "{", StyledPriceAndButton, "{button{min-width:unset;font-size:", props.theme.fontSize.copyTextL, ";span:first-child{padding-left:", props.theme.spacing.large, ";padding-right:", props.theme.spacing.large, ";}svg{width:13px;right:", props.theme.spacing.small, ";}}}}", props.noTabs && floating_sticky_bar_style_ref2, ";" + ( true ? "" : 0),  true ? "" : 0) : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("margin-top:10px;margin-bottom:10px;box-shadow:0 0 14px 0 rgba(0, 0, 0, 0.3);@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{padding:30px;}" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var floating_sticky_bar_style_StyledHeadline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h2",  true ? {
  target: "e6u4gvz2"
} : 0)("font-size:", function (props) {
  return props.theme.fontSize.copyTextXL;
}, ";margin:0 10px 0 0;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{max-width:250px;font-size:", function (props) {
  return props.theme.fontSize.headlineS;
}, ";margin:0 20px 0 0;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{max-width:none;font-size:", function (props) {
  return props.theme.fontSize.headlineL;
}, ";}" + ( true ? "" : 0));

var floating_sticky_bar_style_ref =  true ? {
  name: "1pcp7l4",
  styles: "flex-direction:row;align-items:center;align-self:stretch"
} : 0;

var StyledPriceAndButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e6u4gvz1"
} : 0)("display:flex;padding-left:", function (props) {
  return props.theme.spacing.medium;
}, ";button{@media ", global_style/* mediaQueries.allMobileDevices */.w5.allMobileDevices, "{min-width:auto;}@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{min-width:230px;}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{min-width:260px;}}", function (props) {
  return props.inRow ? floating_sticky_bar_style_ref : /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)("flex-direction:column;align-items:flex-end;button{margin-top:", props.theme.spacing.small, ";}" + ( true ? "" : 0),  true ? "" : 0);
}, ";" + ( true ? "" : 0));
var StyledBoxButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(dreamlines_button/* DreamlinesButton */.P,  true ? {
  target: "e6u4gvz0"
} : 0)( true ? {
  name: "1pumxp9",
  styles: "&&{border-radius:0;height:100%;}"
} : 0);
;// CONCATENATED MODULE: ./src/components/molecules/floating-sticky-bar/floating-sticky-bar.tsx

















var FloatingStickyBar = function FloatingStickyBar(props) {
  var device = react.useContext(device_device/* DeviceContext */.Tp);
  var isMobile = device === 'mobile';
  var formattedOfferCount = (props === null || props === void 0 ? void 0 : props.totalCount) && (0,formatting/* replaceVal */.yy)((0,translation_service.__)('seeAllOffers'), (0,formatting/* numberFormat */.Y4)(props.totalCount));
  var constellationLabelList = props.constellationLabels.map(function (textLabel) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTextLabelListItem, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(label_box/* LabelBox */.q, {
        type: textLabel.type,
        label: (0,translation_service.__)(textLabel.type)
      })
    }, textLabel.type);
  });
  var labelList = props.labelItems && props.labelItems.map(function (textLabel) {
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTextLabelListItem, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(label_box/* LabelBox */.q, {
        type: textLabel.type,
        label: (0,translation_service.__)(textLabel.type)
      })
    }, textLabel.type);
  });
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(sticky/* Sticky */.L, {
    observerRef: props.observerRef,
    height: isMobile ? 0 : undefined,
    children: function children(sticky) {
      return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledSticky, {
        sticky: sticky,
        stageModuleType: props.stageModuleType,
        hide: isMobile,
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledCard, {
          "data-testid": "floating-sticky-bar",
          sticky: sticky,
          noTabs: props.navItems.length === 0,
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row1, {
            children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(floating_sticky_bar_style_StyledHeadline, {
              "data-testid": "headline",
              style: {
                flex: device === 'tablet' ? 'none' : 'unset'
              },
              children: props.title
            }), !isMobile ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(rating/* Rating */.i, {
              value: props.ratingValue,
              string: props.ratingString,
              amount: props.ratingAmount,
              size: "M"
            }) : null, (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTextLabelList, {
              "data-testid": "constellation-labels",
              style: {
                marginLeft: 20,
                marginTop: 0,
                display: sticky ? 'none' : 'initial'
              },
              children: constellationLabelList
            })]
          }), props.stageModuleType === 'searchStage' && device === 'desktop' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledTextLabelList, {
            "data-testid": "label-items",
            style: {
              display: sticky || 'none'
            },
            rows: 1,
            children: labelList
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row2, {
            style: {
              alignSelf: 'stretch'
            },
            children: !!(props !== null && props !== void 0 && props.totalCount) && props.totalCount > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledPriceAndButton, {
              "data-testid": "price-and-btn",
              inRow: sticky,
              children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(price/* Price */.t, {
                price: props.price,
                discount: props.discount,
                size: sticky ? isMobile ? 'S' : 'M' : 'L'
              }), !sticky ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
                onClick: props.onSearchSubmit,
                children: formattedOfferCount
              }) : !isMobile ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBoxButton, {
                wrapperStyle: {
                  alignSelf: 'stretch'
                },
                style: {
                  marginLeft: 10,
                  borderRadius: 0,
                  height: '100%'
                },
                onClick: props.onSearchSubmit,
                children: formattedOfferCount
              }) : (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SvgIcon/* default */.Z, {
                onClick: props.onSearchSubmit,
                style: {
                  color: global_style/* theme.colors.main4 */.rS.colors.main4,
                  marginLeft: 5,
                  height: '100%'
                },
                children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button_style/* StyledRightArrowIcon */.el, {})
              })]
            })
          })]
        }), (props === null || props === void 0 ? void 0 : props.navItems.length) > 0 && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledNavTabs, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NavTabs, {
            title: props.title,
            currentTabIndex: props.currentTabIndex,
            tabs: props.navItems,
            onSelect: props.onTabSelect
          })
        })]
      });
    }
  });
};
// EXTERNAL MODULE: ./src/utils/normalizeLabels.ts
var normalizeLabels = __webpack_require__(22301);
// EXTERNAL MODULE: ./src/components/molecules/cruise-search-mask/cruise-search-mask.tsx + 3 modules
var cruise_search_mask = __webpack_require__(1544);
// EXTERNAL MODULE: ./src/components/sections/frontpage-stage/frontpage-stage.tsx + 1 modules
var frontpage_stage = __webpack_require__(9357);
;// CONCATENATED MODULE: ./src/components/sections/landingpage-stage-search/landingpage-stage-search.style.tsx



var landingpage_stage_search_style_templateObject, landingpage_stage_search_style_templateObject2, landingpage_stage_search_style_templateObject3, _templateObject4, _templateObject5, _templateObject6;

function landingpage_stage_search_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }



var landingpage_stage_search_style_StyledSection = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "eariocm8"
} : 0)( true ? {
  name: "qhxz92",
  styles: "max-width:100%"
} : 0);
var StyledOverlay = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eariocm7"
} : 0)("position:absolute;width:100%;height:60%;bottom:0;z-index:0;left:0;background-image:linear-gradient(\n        to top,\n        ", function (props) {
  return props.theme.colors['main1-50'];
}, ",\n        rgba(0, 35, 59, 0)\n    );", global_style/* media.tablet */.BC.tablet(landingpage_stage_search_style_templateObject || (landingpage_stage_search_style_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["display: none;"]))), ";" + ( true ? "" : 0));
var landingpage_stage_search_style_StyledBgWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eariocm6"
} : 0)("height:200px;position:relative;", global_style/* media.tablet */.BC.tablet(landingpage_stage_search_style_templateObject2 || (landingpage_stage_search_style_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["height: 360px;"]))), " ", global_style/* media.smallDesktop */.BC.smallDesktop(landingpage_stage_search_style_templateObject3 || (landingpage_stage_search_style_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["height: 415px;"]))), " ", global_style/* media.desktop */.BC.desktop(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["height: 440px;"]))), ";" + ( true ? "" : 0));

var landingpage_stage_search_style_ref =  true ? {
  name: "or155a",
  styles: "&&{padding-left:0;padding-right:0;max-width:100%;}"
} : 0;

var StyledStageWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eariocm5"
} : 0)("padding-left:", function (props) {
  return props.theme.spacing.large;
}, ";padding-right:", function (props) {
  return props.theme.spacing.large;
}, ";height:100%;@media ", global_style/* mediaQueries.allTablet */.w5.allTablet, "{max-width:970px;padding-left:0;}@media ", global_style/* mediaQueries.allDesktop */.w5.allDesktop, "{max-width:1170px;}margin:0 auto;", function (props) {
  return props.removePadding && landingpage_stage_search_style_ref;
}, ";" + ( true ? "" : 0));
var StyledCompanyHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "eariocm4"
} : 0)("font-weight:600;font-size:", function (props) {
  return props.theme.fontSize.headlineM;
}, ";text-align:center;text-shadow:0 0 4px ", function (props) {
  return props.theme.dropShadows['black-50'];
}, ";color:", function (props) {
  return props.theme.shades.white;
}, ";display:inline-block;margin:10px 0;@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{text-align:left;margin-bottom:8px;font-size:", function (props) {
  return props.theme.fontSize.headlineXL;
}, ";}@media ", global_style/* mediaQueries.desktopAndUp */.w5.desktopAndUp, "{font-size:", function (props) {
  return props.theme.fontSize.headlineXXL;
}, ";line-height:1;}" + ( true ? "" : 0));
var StyledCompanyLogoWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eariocm3"
} : 0)("float:right;width:95px;height:41px;background-color:white;overflow:hidden;top:7px;position:relative;border-radius:6px;box-shadow:0 6px 8px rgba(0, 0, 0, 0.02);", global_style/* media.tablet */.BC.tablet(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n        width: 120px;\n        height: 60px;\n        top: 24px;\n        right: 24px;\n    "]))), ";" + ( true ? "" : 0));
var StyledCompanyLogo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eariocm2"
} : 0)("padding:1px;width:100%;height:100%;background:url('", function (props) {
  return props.src;
}, "') no-repeat center center;background-size:contain;" + ( true ? "" : 0));
var landingpage_stage_search_style_StyledContentWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "eariocm1"
} : 0)("display:inline-flex;flex-direction:column;position:absolute;bottom:0;left:50%;transform:translateX(-50%);", global_style/* media.tablet */.BC.tablet(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n        position: static;\n        transform: none;\n        display: flex;\n        flex-direction: row;\n        height: 100%;\n    "]))), ";" + ( true ? "" : 0));
var StyledCustomButtonWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "eariocm0"
} : 0)("@media ", global_style/* mediaQueries.tabletAndUp */.w5.tabletAndUp, "{display:none;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ./src/components/sections/landingpage-stage-search/landingpage-stage-search.tsx














var getCruiseStage = function getCruiseStage(title, cruiseSearchFacets, type, pageTypeId, pageProps) {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cruise_search_mask/* CruiseSearchMask */.a, {
    preHeadline: "",
    headline: title,
    type: type,
    pageTypeId: pageTypeId,
    cruiseSearchFacets: cruiseSearchFacets,
    showBadge: false,
    showUSP: false,
    containerMargin: "0",
    pageProps: pageProps
  });
};

var LandingpageStageSearch = function LandingpageStageSearch(_ref, ref) {
  var companyImage = _ref.companyImage,
      title = _ref.title,
      backgroundImage = _ref.backgroundImage,
      totalSearchResultCount = _ref.totalSearchResultCount,
      highestDiscount = _ref.highestDiscount,
      type = _ref.type,
      onSearchSubmit = _ref.onSearchSubmit,
      cruiseSearchFacets = _ref.cruiseSearchFacets,
      pageTypeId = _ref.pageTypeId,
      pageProps = _ref.pageProps;
  var device = (0,device_detection/* getDetectedDevice */.c)();
  var assetPrefix = (0,buildVersion/* getAssetsPrefix */.x)();
  var stageBackgroundFallback = "".concat(assetPrefix, "/static/images/ship-fallback-bg.jpg");
  var totalCount = totalSearchResultCount;
  var formattedOfferCount = totalCount && totalCount > 0 && (0,formatting/* replaceVal */.yy)((0,translation_service.__)('seeAllOffers'), (0,formatting/* numberFormat */.Y4)(totalCount));
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: device === 'mobile' ? (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledStageWrapper, {
      ref: ref,
      removePadding: true,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(frontpage_stage/* FrontpageStage */.X, {
        backgroundImage: "color",
        children: getCruiseStage(title, cruiseSearchFacets, type, pageTypeId, pageProps)
      })
    }) : (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(landingpage_stage_search_style_StyledSection, {
      ref: ref,
      "data-testid": "landingpage-stage",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landingpage_stage_search_style_StyledBgWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(image_image/* NextImage */.o, {
          fill: true,
          placeholder: "",
          imgUrl: backgroundImage || stageBackgroundFallback,
          isBackground: true,
          priority: true,
          customContentStyle: {
            height: '100%'
          },
          style: {
            objectFit: 'cover'
          },
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledOverlay, {}), type !== 'destination' && companyImage && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCompanyLogoWrapper, {
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCompanyLogo, {
              src: companyImage
            })
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledStageWrapper // I know 🙄
          , {
            removePadding: device === 'tablet' && Boolean(highestDiscount),
            children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landingpage_stage_search_style_StyledContentWrapper, {
              children: getCruiseStage(title, cruiseSearchFacets, type, pageTypeId, pageProps)
            })
          })]
        })
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledCustomButtonWrapper, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dreamlines_button/* DreamlinesButton */.P, {
          primary: true,
          wrapperStyle: {
            width: '100%'
          },
          style: {
            borderRadius: 0,
            fontWeight: 600,
            width: '100%'
          },
          onClick: onSearchSubmit,
          children: formattedOfferCount
        })
      })]
    })
  });
};

/* harmony default export */ var landingpage_stage_search = (/*#__PURE__*/react.memo( /*#__PURE__*/react.forwardRef(LandingpageStageSearch)));
;// CONCATENATED MODULE: ./src/modules/stage-mod.tsx




function stage_mod_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function stage_mod_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? stage_mod_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : stage_mod_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















var StageMod = function StageMod(_ref) {
  var _stageData$cruiseSear, _highestDiscount$item, _highestDiscount$item2, _cheapestPrice$items$, _cheapestPrice$items$2, _stageData$cruiseSear2, _stageData$cruiseSear3, _props$icons, _stageData$cruiseSear4, _stageData$cruiseSear5, _stageData$cruiseSear6, _stageData$cruiseSear7;

  var pageProps = _ref.pageProps,
      ugcProps = _ref.ugcProps,
      navItems = _ref.navItems,
      currentTabIndex = _ref.currentTabIndex,
      onTabMenuSelect = _ref.onTabMenuSelect,
      onSearchSubmit = _ref.onSearchSubmit,
      stageModuleType = _ref.stageModuleType;

  var _React$useState = react.useState({
    cruiseSearchlandingpageStage: null,
    cruiseSearchFacetslandingpage: null
  }),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      stageData = _React$useState2[0],
      setStageData = _React$useState2[1];

  react.useEffect(function () {
    Promise.all([// TODO: we are doing almost similar fetch in [...landingpage] component
    // but with limit: 6 maybe we can reuse data we from that request or idk
    // added it here because in graph ql query  property `cruiseSearchlandingpageStage` has separate request with limit=3
    (0,resources/* searchCruises */.vM)({
      slug: pageProps.getLandingPage.slug,
      limit: 3,
      sortBy: 'relevance'
    }), (0,resources/* searchCruiseFacets */.lP)({
      shipId: pageProps.getLandingPage.id,
      limit: 9999
    })]).then(function (data) {
      var _data = (0,slicedToArray/* default */.Z)(data, 2),
          cruiseSearchlandingpageStage = _data[0],
          cruiseSearchFacetslandingpage = _data[1];

      setStageData({
        cruiseSearchlandingpageStage: cruiseSearchlandingpageStage,
        cruiseSearchFacetslandingpage: cruiseSearchFacetslandingpage
      });
    }).catch(function (err) {
      throw Error('Stage mod data fetch failed');
    });
  }, []); // Dummy variable

  var device = react.useContext(device_device/* DeviceContext */.Tp);
  var getLandingPage = pageProps.getLandingPage,
      modulesData = pageProps.modulesData;
  var highestDiscount = modulesData === null || modulesData === void 0 ? void 0 : modulesData.cruiseSearchlandingpageHighestDiscount;
  var cheapestPrice = modulesData === null || modulesData === void 0 ? void 0 : modulesData.cruiseSearchlandingpageCheapestPrice;
  var observerRef = react.useRef(null);
  var cruisesearchFacetsData = (_stageData$cruiseSear = stageData === null || stageData === void 0 ? void 0 : stageData.cruiseSearchFacetslandingpage) !== null && _stageData$cruiseSear !== void 0 ? _stageData$cruiseSear : {
    kind: '',
    currentItemCount: 0,
    totalCount: 0,
    items: []
  };
  var props = getShipProps(pageProps);
  var maxDiscount = highestDiscount === null || highestDiscount === void 0 ? void 0 : (_highestDiscount$item = highestDiscount.items[0]) === null || _highestDiscount$item === void 0 ? void 0 : (_highestDiscount$item2 = _highestDiscount$item.sailings) === null || _highestDiscount$item2 === void 0 ? void 0 : _highestDiscount$item2.maxDiscount;
  var minSailPrice = cheapestPrice === null || cheapestPrice === void 0 ? void 0 : (_cheapestPrice$items$ = cheapestPrice.items[0]) === null || _cheapestPrice$items$ === void 0 ? void 0 : (_cheapestPrice$items$2 = _cheapestPrice$items$.sailings) === null || _cheapestPrice$items$2 === void 0 ? void 0 : _cheapestPrice$items$2.minPrice;
  var minPrice = minSailPrice ? Number((minSailPrice / 2).toFixed(0)) : undefined; // p.P price

  var totalCount = (_stageData$cruiseSear2 = stageData === null || stageData === void 0 ? void 0 : (_stageData$cruiseSear3 = stageData.cruiseSearchlandingpageStage) === null || _stageData$cruiseSear3 === void 0 ? void 0 : _stageData$cruiseSear3.totalCount) !== null && _stageData$cruiseSear2 !== void 0 ? _stageData$cruiseSear2 : 0;
  var icons = (props === null || props === void 0 ? void 0 : (_props$icons = props.icons) === null || _props$icons === void 0 ? void 0 : _props$icons.length) > 0 ? props.icons.map(function (icon) {
    return stage_mod_objectSpread(stage_mod_objectSpread({}, icon), {}, {
      iconColor: global_style/* theme.colors.main4 */.rS.colors.main4,
      fontColor: global_style/* theme.shades.blackGrey */.rS.shades.blackGrey,
      horizontal: true
    });
  }) : [];
  var ugcLabels = (_stageData$cruiseSear4 = stageData === null || stageData === void 0 ? void 0 : (_stageData$cruiseSear5 = stageData.cruiseSearchlandingpageStage) === null || _stageData$cruiseSear5 === void 0 ? void 0 : (_stageData$cruiseSear6 = _stageData$cruiseSear5.items) === null || _stageData$cruiseSear6 === void 0 ? void 0 : (_stageData$cruiseSear7 = _stageData$cruiseSear6[0]) === null || _stageData$cruiseSear7 === void 0 ? void 0 : _stageData$cruiseSear7.ugcLabels) !== null && _stageData$cruiseSear4 !== void 0 ? _stageData$cruiseSear4 : [];
  var searchResult = stageData.cruiseSearchlandingpageStage || {
    items: [],
    totalCount: 0
  };
  var labelItems = (0,normalizeLabels/* normalizeLabels */.Z)({
    ugcLabels: ugcLabels || [],
    excludeCluster: ['constellation', 'productData']
  }) || [];
  var constellationLabels = (0,normalizeLabels/* normalizeLabels */.Z)({
    ugcLabels: ugcLabels || [],
    excludeCluster: ['productData', 'shipRatings', 'experienceLabels', 'ageRange', 'routeRatings', 'atmosphere', 'ugcReview']
  }) || [];

  var handleTabSelect = function handleTabSelect(tab) {
    if (tab < 0 || tab > navItems.length) return;
    var selectedMenuItem = navItems.find(function (item) {
      return item.name === navItems[tab].name;
    });

    if (!selectedMenuItem) {
      return false;
    }

    EventTracker/* eventTracker.track */.xT.track({
      event: 'click',
      category: 'sticky-navigation',
      action: "navigation-".concat(selectedMenuItem.name),
      label: "".concat(getLandingPage.type, "-").concat(getLandingPage.title)
    });
    onTabMenuSelect === null || onTabMenuSelect === void 0 ? void 0 : onTabMenuSelect(selectedMenuItem);
  };

  var getNavItems = (0,react.useMemo)(function () {
    return navItems.reduce(function (acc, nav) {
      var tabTitle = (0,translation_service.__)(nav.titleTranslationKey);

      if (nav.name === shipLanding/* sectionNames.reviews */.A0.reviews) {
        if (!ugcProps || ugcProps.totalRatings === 0) {
          return acc;
        }

        tabTitle = (0,formatting/* replaceVal */.yy)(tabTitle, (0,formatting/* numberFormat */.Y4)(ugcProps.totalRatings, {
          maxDecimals: 1
        }), /\[amount]/g);
      }

      acc.push({
        key: nav.name,
        title: tabTitle
      });
      return acc;
    }, []);
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [stageModuleType === 'searchStage' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(landingpage_stage_search, {
      totalSearchResultCount: (searchResult === null || searchResult === void 0 ? void 0 : searchResult.totalCount) || 0,
      highestDiscount: maxDiscount,
      type: getLandingPage.type,
      backgroundImage: props === null || props === void 0 ? void 0 : props.backgroundImage,
      title: getLandingPage.title,
      companyImage: props !== null && props !== void 0 && props.companyImage ? props.companyImage : '',
      onSearchSubmit: onSearchSubmit,
      cruiseSearchFacets: cruisesearchFacetsData,
      pageTypeId: getLandingPage.id,
      pageProps: pageProps
    }), device !== 'mobile' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledOffsetMargin, {
      offsetDown: stageModuleType === 'searchStage'
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
      ref: observerRef,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FloatingStickyBar, {
        title: getLandingPage.title,
        icons: icons,
        labelItems: labelItems.map(function (label) {
          return {
            type: label.label,
            label: label.label
          };
        }),
        constellationLabels: constellationLabels.map(function (label) {
          return {
            type: label.label,
            label: label.label
          };
        }),
        ratingValue: ugcProps === null || ugcProps === void 0 ? void 0 : ugcProps.ratingValue,
        ratingString: ugcProps === null || ugcProps === void 0 ? void 0 : ugcProps.ratingString,
        ratingAmount: ugcProps === null || ugcProps === void 0 ? void 0 : ugcProps.totalRatings,
        price: minPrice,
        discount: maxDiscount,
        totalCount: totalCount,
        navItems: getNavItems,
        stageModuleType: stageModuleType,
        onTabSelect: handleTabSelect,
        currentTabIndex: currentTabIndex,
        onSearchSubmit: onSearchSubmit,
        observerRef: observerRef
      })
    })]
  });
};

var getShipProps = function getShipProps(_ref2) {
  var _shipModuleData$compa;

  var getLandingPage = _ref2.getLandingPage,
      modulesData = _ref2.modulesData;
  var shipModuleData = modulesData["ship".concat(getLandingPage.id)];

  if (!shipModuleData) {
    throw new Error('getShipProps called without data');
  } // @TODO: fix thumbor types


  var companyImage = (shipModuleData === null || shipModuleData === void 0 ? void 0 : (_shipModuleData$compa = shipModuleData.company) === null || _shipModuleData$compa === void 0 ? void 0 : _shipModuleData$compa.logoFilepath) || '';
  var backgroundImage = (shipModuleData === null || shipModuleData === void 0 ? void 0 : shipModuleData.bannerImage) || '';
  var icons = [];
  var data = modulesData["".concat(getLandingPage.type).concat(getLandingPage.id)];

  if (data !== null && data !== void 0 && data.factsAndFigures) {
    var _data$factsAndFigures = data.factsAndFigures,
        manufactureYear = _data$factsAndFigures.manufactureYear,
        passengerCapacity = _data$factsAndFigures.passengerCapacity,
        crewMembers = _data$factsAndFigures.crewMembers,
        decks = _data$factsAndFigures.decks;

    if (manufactureYear) {
      icons.push({
        type: 'buildYear',
        amount: "".concat(manufactureYear)
      });
    }

    if (passengerCapacity) {
      icons.push({
        type: 'passenger',
        amount: "".concat(passengerCapacity)
      });
    }

    if (crewMembers) {
      icons.push({
        type: 'crew',
        amount: "".concat(crewMembers)
      });
    }

    if (decks) {
      icons.push({
        type: 'decks',
        amount: "".concat(decks)
      });
    }
  }

  return {
    companyImage: companyImage,
    backgroundImage: backgroundImage,
    icons: icons
  };
};

var StyledOffsetMargin = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e83dy1t0"
} : 0)("margin-bottom:", function (props) {
  return props.offsetDown ? '40px' : '-40px';
}, ";@media ", global_style/* mediaQueries.allTablet */.w5.allTablet, "{margin-bottom:", function (props) {
  return props.offsetDown ? '40px' : '-30px';
}, ";}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./src/components/sections/header/TrustBadges.tsx
var TrustBadges = __webpack_require__(10670);
// EXTERNAL MODULE: ./src/components/sections/header/header-mobile-old/Icons/PhoneFilledIcon.tsx
var PhoneFilledIcon = __webpack_require__(10085);
;// CONCATENATED MODULE: ./src/components/molecules/call-us-footer/call-us-footer.style.tsx


function call_us_footer_style_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }


var CallUsButton = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("a",  true ? {
  target: "e1ybc3675"
} : 0)("width:100%;padding:8px 16px;background:linear-gradient(\n        to right,\n        ", function (_ref) {
  var theme = _ref.theme;
  return theme.colorsUnifications.golden[100];
}, ",\n        ", function (_ref2) {
  var theme = _ref2.theme;
  return theme.colorsUnifications.yellowSea[100];
}, "\n    );box-shadow:0 2px 6px 0 rgba(0, 0, 0, 0.12);border-radius:6px;align-items:center;color:", function (_ref3) {
  var theme = _ref3.theme;
  return theme.text.color.primary;
}, ";display:flex;border:1px solid ", function (_ref4) {
  var theme = _ref4.theme;
  return theme.colorsUnifications.yellowSea[100];
}, ";max-width:400px;text-decoration:none;&:hover,&:active,&:visited{color:", function (_ref5) {
  var theme = _ref5.theme;
  return theme.text.color.primary;
}, ";text-decoration:none;}" + ( true ? "" : 0));
var call_us_footer_style_Container = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ybc3674"
} : 0)("width:100%;padding:0 16px;position:fixed;z-index:9;bottom:16px;display:flex;justify-content:center;", function (_ref6) {
  var theme = _ref6.theme;
  return theme.media.mdAndUp;
}, "{display:none;}" + ( true ? "" : 0));
var TitleWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1ybc3673"
} : 0)( true ? {
  name: "1hbghox",
  styles: "display:flex;flex-direction:column;gap:4px;width:100%;align-items:center"
} : 0);
var CallUsTitle = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h4",  true ? {
  target: "e1ybc3672"
} : 0)( true ? {
  name: "acq5hw",
  styles: "font-size:17px;font-weight:700;margin:0;text-align:center"
} : 0);
var CallUsNumber = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("span",  true ? {
  target: "e1ybc3671"
} : 0)( true ? {
  name: "rnnx2x",
  styles: "font-size:12px"
} : 0);
var StyledPhoneIcon = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(PhoneFilledIcon/* PhoneFilledIcon */.W,  true ? {
  target: "e1ybc3670"
} : 0)( true ? {
  name: "1oknfkt",
  styles: "height:24px;width:24px;flex-shrink:0"
} : 0);
;// CONCATENATED MODULE: ./src/components/molecules/call-us-footer/call-us-footer.tsx






var CallUsFooter = function CallUsFooter(_ref) {
  var phoneNumber = _ref.phoneNumber,
      pageType = _ref.pageType;

  var _useState = (0,react.useState)(''),
      url = _useState[0],
      setUrl = _useState[1];

  var handleClick = function handleClick() {
    EventTracker/* eventTracker.ga4Track */.xT.ga4Track('call_us_banner', {
      page_type: pageType,
      page_url: url
    });
  };

  (0,react.useEffect)(function () {
    setUrl(window.location.href);
  }, [pageType]);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(call_us_footer_style_Container, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CallUsButton, {
      onClick: handleClick,
      href: "tel:".concat(phoneNumber),
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledPhoneIcon, {
        width: 20,
        height: 20
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TitleWrapper, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CallUsTitle, {
          children: (0,translation_service.__)('callustitle')
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CallUsNumber, {
          children: phoneNumber
        })]
      })]
    })
  });
};
;// CONCATENATED MODULE: ./pages/ship/[slug]/index.tsx




function _slug_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _slug_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? _slug_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : _slug_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _slug_EMOTION_STRINGIFIED_CSS_ERROR_() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

















var getActiveSubMenuItems = function getActiveSubMenuItems(subMenuItemsConfig, shipData) {
  var inactiveSubMenuItems = [];
  var livePositionData = shipData === null || shipData === void 0 ? void 0 : shipData.livePosition;

  if (!livePositionData || !livePositionData.latitude || !livePositionData.longitude) {
    inactiveSubMenuItems.push(shipLanding/* sectionNames.shipLivePosition */.A0.shipLivePosition);
  }

  if (!(shipData !== null && shipData !== void 0 && shipData.decks)) {
    inactiveSubMenuItems.push(shipLanding/* sectionNames.cabin */.A0.cabin);
  }

  return subMenuItemsConfig.filter(function (item) {
    return !inactiveSubMenuItems.includes(item.name);
  });
};

var ShipLandingPage = function ShipLandingPage(props) {
  var _props$pageProps, _props$pageProps2, _props$pageProps3, _props$pageProps3$get;

  var device = react.useContext(device_device/* DeviceContext */.Tp);
  var localeConfig = react.useContext(locale_config/* LocaleConfigContext */.nO);

  var _React$useState = react.useState(0),
      _React$useState2 = (0,slicedToArray/* default */.Z)(_React$useState, 2),
      currentTabIndex = _React$useState2[0],
      setCurrentTabIndex = _React$useState2[1];

  var modulesData = props === null || props === void 0 ? void 0 : (_props$pageProps = props.pageProps) === null || _props$pageProps === void 0 ? void 0 : _props$pageProps.modulesData;
  var landingPage = props === null || props === void 0 ? void 0 : (_props$pageProps2 = props.pageProps) === null || _props$pageProps2 === void 0 ? void 0 : _props$pageProps2.getLandingPage;
  var meta = props === null || props === void 0 ? void 0 : (_props$pageProps3 = props.pageProps) === null || _props$pageProps3 === void 0 ? void 0 : (_props$pageProps3$get = _props$pageProps3.getLandingPage) === null || _props$pageProps3$get === void 0 ? void 0 : _props$pageProps3$get.meta;
  var shipData = modulesData["ship".concat(landingPage.id)];
  var subMenuItems = getActiveSubMenuItems(shipLanding/* subMenuItems */.WM, shipData);
  var hostUrl = props === null || props === void 0 ? void 0 : props.hostUrl;
  /**
   * `mobile = 115` | `tablet = 105` | `desktop = 105`
   */

  var HEADER_HEIGHT = device === 'mobile' ? 130 : 120;
  /**
   * Define `refs` for each _section_ / _module_ on the page, so we can track if it's on screen
   */

  var refs = react.useMemo(function () {
    return subMenuItems.reduce(function (acc, value) {
      acc[value.name] = /*#__PURE__*/react.createRef();
      return acc;
    }, {});
  }, []);

  var _useElementOnScreen = useElementOnScreen({
    refs: refs,
    offset: HEADER_HEIGHT
  }),
      currentElementName = _useElementOnScreen.currentElementName;

  react.useEffect(function () {
    var index = subMenuItems.findIndex(function (item) {
      return item.name === currentElementName;
    });
    setCurrentTabIndex(index > -1 ? index : currentTabIndex);
  }, [subMenuItems, currentTabIndex, currentElementName]);
  /**
   * Using `window.scrollTo` to scroll page to the specific section
   * `behavior = 'smooth'` is currently **not supported** from some browsers: _IE11 or Safari_
   *
   * More info here: `https://caniuse.com/#search=scrollto%20behavior`
   */

  var handleTabMenuClicked = react.useCallback(function (selectedMenuItem) {
    if (!selectedMenuItem) return;
    var ref = refs[selectedMenuItem.name];
    (ref === null || ref === void 0 ? void 0 : ref.current) && // +5 is just a weird bug to always detect section that is on view
    // btw, IE11 does not support passing object to scrollTo, but we are using css
    // scroll-behavior: smooth
    window.scrollTo(0, ref.current.offsetTop - HEADER_HEIGHT + 5);
  }, [refs, HEADER_HEIGHT]);
  var handleSubmit = (0,useHandleSearchSubmit/* useHandleSearchSubmit */.r)({
    id: landingPage.id,
    type: landingPage.type,
    title: landingPage.title
  });

  var headTagsData = _slug_objectSpread(_slug_objectSpread({}, meta), {}, {
    hostUrl: hostUrl,
    landingPage: landingPage,
    modulesData: modulesData,
    pageType: 'landingPage'
  });

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(head_tags/* HeadTags */.c, _slug_objectSpread({}, headTagsData)), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LandingPageContainer, {
      ref: refs['stage'],
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StageMod, {
        pageProps: props.pageProps,
        ugcProps: (0,ugc_data/* getUGCPropsFromData */.Hz)(_slug_objectSpread(_slug_objectSpread({}, props.pageProps), {}, {
          ugcSlug: localeConfig.slugs.ugc
        })),
        navItems: subMenuItems,
        currentTabIndex: currentTabIndex,
        onTabMenuSelect: function onTabMenuSelect(selectedMenuItem) {
          return handleTabMenuClicked(selectedMenuItem);
        },
        onSearchSubmit: handleSubmit,
        stageModuleType: "searchStage"
      })
    }, "stage-container"), device === 'mobile' && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BadgesContainer, {
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrustBadges/* TrustBadges */.j, {
        portal: localeConfig.url
      })
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CallUsFooter, {
      phoneNumber: localeConfig.phoneNumber,
      pageType: props.pageProps.pageType
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ship_sections, {
      pageProps: props.pageProps,
      refs: refs
    })]
  });
};

var LandingPageContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efi2xs21"
} : 0)( true ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : 0);

var BadgesContainer = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "efi2xs20"
} : 0)( true ? {
  name: "hbr5yu",
  styles: "padding-top:24px;background:#fff"
} : 0);

var __N_SSP = true;
/* harmony default export */ var _slug_ = (ShipLandingPage);

/***/ }),

/***/ 9357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ FrontpageStage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71383);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js + 3 modules
var emotion_styled_base_browser_esm = __webpack_require__(61516);
// EXTERNAL MODULE: ./src/style/global-style.tsx
var global_style = __webpack_require__(43780);
;// CONCATENATED MODULE: ./src/components/sections/frontpage-stage/frontpage-stage.style.tsx



var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;


var StyledFrontpageStage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1uct2zp1"
} : 0)("background:", function (props) {
  return props.background === 'color' ? props.theme.colors.main1 : "url(".concat(props.background, ") no-repeat center center");
}, ";width:100%;padding-bottom:24px;text-align:", function (props) {
  return props.background === 'color' ? 'center' : 'left';
}, ";background-size:cover;", global_style/* media.tablet */.BC.tablet(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n        height: 573px;\n    "]))), " ", global_style/* media.smallDesktop */.BC.smallDesktop(_templateObject2 || (_templateObject2 = (0,taggedTemplateLiteral/* default */.Z)(["\n        height: 640px;\n    "]))), " ", global_style/* media.bigDesktop */.BC.bigDesktop(_templateObject3 || (_templateObject3 = (0,taggedTemplateLiteral/* default */.Z)(["\n        width: 1920px;\n        height: 550px;\n        margin: 0 auto;\n    "]))), ";" + ( true ? "" : 0));
var StyledHeadlineStage = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("h1",  true ? {
  target: "e1uct2zp0"
} : 0)("font-size:32px;line-height:32px;padding-top:4.5%;color:", function (props) {
  return props.theme.shades.white;
}, ";", global_style/* media.tablet */.BC.tablet(_templateObject4 || (_templateObject4 = (0,taggedTemplateLiteral/* default */.Z)(["\n        font-size: 54px;\n        line-height: 63px;\n        text-align: center;\n    "]))), " ", global_style/* media.smallDesktop */.BC.smallDesktop(_templateObject5 || (_templateObject5 = (0,taggedTemplateLiteral/* default */.Z)(["\n        font-size: 104px;\n        line-height: 102px;\n    "]))), " span{font-weight:normal;font-size:19px;display:block;", global_style/* media.tablet */.BC.tablet(_templateObject6 || (_templateObject6 = (0,taggedTemplateLiteral/* default */.Z)(["\n            font-weight: bold;\n            font-size: 20px;\n        "]))), " ", global_style/* media.smallDesktop */.BC.smallDesktop(_templateObject7 || (_templateObject7 = (0,taggedTemplateLiteral/* default */.Z)(["\n            font-size: 30px;\n        "]))), ";}" + ( true ? "" : 0));
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./src/components/sections/frontpage-stage/frontpage-stage.tsx



var FrontpageStage = function FrontpageStage(props) {
  var backgroundImage = props.backgroundImage,
      children = props.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledFrontpageStage, {
    "data-testid": "frontpage-stage",
    background: backgroundImage,
    children: children
  });
};

/***/ }),

/***/ 5264:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ship/[slug]",
      function () {
        return __webpack_require__(50938);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4929,8263,6871,8371,64,7314,2833,1186,2022,7038,7299,9866,9543,2848,7486,1133,3728,6154,8090,9231,9629,9774,2888,179], function() { return __webpack_exec__(5264); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);